// 颜色变量定义
export const EmptyColors = {
  // 灰色系列
  gray100: '#E7EAF0',
  gray200: '#D9DFE8',
  gray300: '#A2ABB9',
}

export const renderEmpty = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="106"
    viewBox="0 0 120 106"
    fill="none"
  >
    <path
      d="M29.5265 67.7035C29.5588 67.8325 29.5992 67.9695 29.6476 68.1146L29.7445 68.5015C29.7768 68.6304 29.793 68.7352 29.793 68.8158C29.793 69.2671 29.6719 69.6661 29.4297 70.0126C29.1875 70.3592 28.8726 70.6131 28.4851 70.7743C28.3398 70.7904 28.1864 70.7985 28.0249 70.7985C27.8957 70.8146 27.7504 70.8226 27.5889 70.8226H27.1287L23.3504 70.871V74.9089C23.3504 75.5053 23.3625 76.1058 23.3868 76.7103C23.411 77.3148 23.4392 77.8588 23.4715 78.3424C23.5038 78.9227 23.5442 79.4788 23.5926 80.0107H20.1049L20.1776 79.0677C20.1937 78.697 20.2099 78.1933 20.226 77.5565C20.2422 76.9198 20.2503 76.0695 20.2503 75.0056V71.3062C19.9758 71.548 19.669 71.6689 19.3299 71.6689C19.0554 71.6689 18.8172 71.6044 18.6154 71.4755C18.4136 71.3465 18.2481 71.1692 18.1189 70.9435L15.382 70.7985C14.8492 70.6695 14.4052 70.3995 14.0499 69.9885C13.6947 69.5774 13.5171 69.0898 13.5171 68.5256C13.5171 68.4289 13.5252 68.3403 13.5413 68.2597C13.5575 68.1791 13.5817 68.0985 13.614 68.0179L14.2195 66.6155C14.2518 66.2609 14.3527 65.9304 14.5222 65.6241C14.6918 65.3179 14.9057 65.0519 15.1641 64.8262L18.9666 57.7901H18.9908C19.2976 57.2259 19.6609 56.7423 20.0807 56.3393C20.5005 55.9364 21.0414 55.7349 21.7035 55.7349C22.2847 55.7349 22.8055 55.888 23.2657 56.1943C23.7258 56.5005 24.069 56.9035 24.295 57.4032L27.3467 63.3755C27.8957 63.5689 28.3478 63.9074 28.7031 64.391C29.0583 64.8746 29.2359 65.4307 29.2359 66.0594C29.2359 66.3173 29.1955 66.5913 29.1148 66.8814L29.5265 67.7035Z"
      fill="url(#paint0_linear_2242_16102)"
    />
    <path
      d="M115.044 67.7035C115.076 67.8325 115.116 67.9695 115.165 68.1146L115.262 68.5015C115.294 68.6304 115.31 68.7352 115.31 68.8158C115.31 69.2671 115.189 69.6661 114.947 70.0126C114.705 70.3592 114.39 70.6131 114.002 70.7743C113.857 70.7904 113.703 70.7985 113.542 70.7985C113.413 70.8146 113.267 70.8226 113.106 70.8226H112.646L108.868 70.871V74.9089C108.868 75.5053 108.88 76.1058 108.904 76.7103C108.928 77.3148 108.956 77.8588 108.989 78.3424C109.021 78.9227 109.061 79.4788 109.11 80.0107H105.622L105.695 79.0677C105.711 78.697 105.727 78.1933 105.743 77.5565C105.759 76.9198 105.767 76.0695 105.767 75.0056V71.3062C105.493 71.548 105.186 71.6689 104.847 71.6689C104.572 71.6689 104.334 71.6044 104.132 71.4755C103.931 71.3465 103.765 71.1692 103.636 70.9435L100.899 70.7985C100.366 70.6695 99.9222 70.3995 99.567 69.9885C99.2118 69.5774 99.0342 69.0898 99.0342 68.5256C99.0342 68.4289 99.0423 68.3403 99.0584 68.2597C99.0745 68.1791 99.0988 68.0985 99.1311 68.0179L99.7366 66.6155C99.7689 66.2609 99.8698 65.9304 100.039 65.6241C100.209 65.3179 100.423 65.0519 100.681 64.8262L104.484 57.7901H104.508C104.815 57.2259 105.178 56.7423 105.598 56.3393C106.018 55.9364 106.559 55.7349 107.221 55.7349C107.802 55.7349 108.323 55.888 108.783 56.1943C109.243 56.5005 109.586 56.9035 109.812 57.4032L112.864 63.3755C113.413 63.5689 113.865 63.9074 114.22 64.391C114.575 64.8746 114.753 65.4307 114.753 66.0594C114.753 66.3173 114.713 66.5913 114.632 66.8814L115.044 67.7035Z"
      fill="url(#paint1_linear_2242_16102)"
    />
    <path
      d="M104.896 70.3606C104.921 70.4617 104.952 70.5692 104.99 70.6829L105.065 70.9862C105.091 71.0874 105.103 71.1695 105.103 71.2327C105.103 71.5866 105.009 71.8994 104.82 72.1712C104.631 72.4429 104.386 72.642 104.084 72.7684C103.97 72.781 103.851 72.7873 103.725 72.7873C103.624 72.8 103.511 72.8063 103.385 72.8063H103.026L100.08 72.8442V76.0103C100.08 76.4779 100.09 76.9487 100.109 77.4227C100.127 77.8967 100.149 78.3232 100.175 78.7024C100.2 79.1574 100.231 79.5935 100.269 80.0106H97.5499L97.6065 79.2712C97.6191 78.9805 97.6317 78.5855 97.6443 78.0863C97.6569 77.587 97.6632 76.9203 97.6632 76.0861V73.1854C97.4491 73.375 97.21 73.4698 96.9456 73.4698C96.7316 73.4698 96.5459 73.4193 96.3885 73.3182C96.2312 73.217 96.1021 73.078 96.0014 72.9011L93.8676 72.7873C93.4522 72.6862 93.106 72.4745 92.829 72.1522C92.5521 71.8299 92.4136 71.4476 92.4136 71.0052C92.4136 70.9294 92.4199 70.8598 92.4325 70.7967C92.445 70.7335 92.4639 70.6703 92.4891 70.6071L92.9612 69.5075C92.9864 69.2294 93.065 68.9703 93.1972 68.7302C93.3294 68.49 93.4962 68.2815 93.6976 68.1045L96.6623 62.5876H96.6812C96.9204 62.1452 97.2037 61.766 97.531 61.45C97.8583 61.1341 98.28 60.9761 98.7962 60.9761C99.2494 60.9761 99.6554 61.0961 100.014 61.3363C100.373 61.5764 100.64 61.8924 100.817 62.2842L103.196 66.967C103.624 67.1187 103.977 67.3841 104.253 67.7633C104.53 68.1424 104.669 68.5785 104.669 69.0714C104.669 69.2736 104.637 69.4885 104.574 69.716L104.896 70.3606Z"
      fill="url(#paint2_linear_2242_16102)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.3448 73.666C75.2771 73.666 90.5248 75.0472 101.183 77.2533C111.607 77.3227 120 80.4451 120 84.2867C120 87.3313 114.728 89.9241 107.351 90.9034C105.591 91.4244 103.609 91.9154 101.432 92.3716C101.489 92.6623 101.517 92.956 101.517 93.2522C101.517 99.9558 86.9433 105.39 68.9655 105.39C52.7912 105.39 39.3721 100.991 36.8425 95.2271C15.2605 93.5883 0 89.5546 0 84.8384C0 78.6681 26.1219 73.666 58.3448 73.666Z"
      fill="var(--xzx-brand-1)"
    />
    <mask
      id="mask0_2242_16102"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="73"
      width="120"
      height="33"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.3448 73.666C75.2771 73.666 90.5248 75.0472 101.183 77.2533C111.607 77.3227 120 80.4451 120 84.2867C120 87.3313 114.728 89.9241 107.351 90.9034C105.591 91.4244 103.609 91.9154 101.432 92.3716C101.489 92.6623 101.517 92.956 101.517 93.2522C101.517 99.9558 86.9433 105.39 68.9655 105.39C52.7912 105.39 39.3721 100.991 36.8425 95.2271C15.2605 93.5883 0 89.5546 0 84.8384C0 78.6681 26.1219 73.666 58.3448 73.666Z"
        fill="var(--xzx-brand-1)"
      />
    </mask>
    <g mask="url(#mask0_2242_16102)">
      <path
        d="M55.6309 79.185L66.9269 65.723L134.952 99.71L94.8116 129.768L55.6309 79.185Z"
        fill="url(#paint3_linear_2242_16102)"
      />
    </g>
    <path
      d="M87.4485 53.7231L59.5864 50.2178V64.1186L87.0034 67.3212L87.4485 53.7231Z"
      fill="var(--xzx-brand-4)"
    />
    <path
      d="M37.5171 54.7537L59.5826 50.2178L59.5861 65.8471L37.5171 70.3557V54.7537Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M63.4482 60.7478L87.1724 54.6313V83.5494L63.4482 89.6658V60.7478Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M37.793 55.459L63.724 60.6308L63.5731 89.6659L37.793 83.9068V55.459Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M63.7241 60.7496L37.5634 55.1831L32 65.4364L58.6051 71.7348L63.7241 60.7496Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M63.7241 60.6225L87.472 54.0796L93.5172 64.2622L70.7716 71.7348L63.7241 60.6225Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M38.4153 12.9683C31.6806 22.6122 34.5412 29.8101 46.9973 34.5619"
      stroke="url(#paint4_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <path
      d="M36.0977 32.937C38.3773 35.7698 40.448 37.1861 42.31 37.1861"
      stroke="url(#paint5_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <path
      d="M91.0971 0.610352C91.402 9.18189 83.347 15.1839 66.9321 18.6163"
      stroke="url(#paint6_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <path
      d="M93.2869 11.3965C89.2598 14.7718 86.1103 16.4595 83.8384 16.4595"
      stroke="url(#paint7_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <path
      d="M86.6204 30.9957C70.7687 29.0819 60.8064 33.1642 56.7334 43.2425"
      stroke="url(#paint8_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <path
      d="M38.0454 19.5928C47.4096 21.0598 51.2427 23.6507 49.5447 27.3654C47.8466 31.0802 44.0136 28.4893 38.0454 19.5928Z"
      fill="url(#paint9_linear_2242_16102)"
    />
    <path
      d="M71.6768 11.3965C73.047 6.5458 76.6277 4.92888 82.4189 6.5458C82.1693 8.77105 78.5886 10.388 71.6768 11.3965Z"
      fill="url(#paint10_linear_2242_16102)"
    />
    <path
      d="M59.1187 46.8288C63.3951 38.5116 69.3716 36.1432 77.048 39.7237C73.4673 46.3479 67.4908 48.7163 59.1187 46.8288Z"
      fill="url(#paint11_linear_2242_16102)"
    />
    <path
      d="M70.3447 13.9279C71.3927 11.6818 72.7718 10.2435 74.4822 9.61328"
      stroke="url(#paint12_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <path
      d="M46.9971 26.2681C48.9558 26.7219 49.9351 28.6057 49.9351 31.9195"
      stroke="url(#paint13_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <path
      d="M57.2852 49.4887C58.8753 46.4536 61.0825 44.936 63.9068 44.936"
      stroke="url(#paint14_linear_2242_16102)"
      stroke-width="0.3"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2242_16102"
        x1="29.793"
        y1="67.8728"
        x2="13.5171"
        y2="67.8728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2242_16102"
        x1="115.31"
        y1="67.8728"
        x2="99.0342"
        y2="67.8728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2242_16102"
        x1="105.103"
        y1="70.4933"
        x2="92.4136"
        y2="70.4933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2242_16102"
        x1="73.6551"
        y1="78.6312"
        x2="94.0689"
        y2="99.3208"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2242_16102"
        x1="38.3443"
        y1="12.7005"
        x2="31.5613"
        y2="27.7192"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2242_16102"
        x1="36.1375"
        y1="33.114"
        x2="42.2267"
        y2="37.222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2242_16102"
        x1="91.4443"
        y1="-0.321937"
        x2="66.0172"
        y2="16.3029"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2242_16102"
        x1="93.4193"
        y1="11.1343"
        x2="85.6498"
        y2="18.1956"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2242_16102"
        x1="87.0394"
        y1="29.8798"
        x2="67.6335"
        y2="52.112"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2242_16102"
        x1="49.8807"
        y1="20.9534"
        x2="37.3201"
        y2="24.3675"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2242_16102"
        x1="82.3693"
        y1="6.7282"
        x2="72.0373"
        y2="11.105"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2242_16102"
        x1="76.9651"
        y1="39.4587"
        x2="59.5858"
        y2="46.6311"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2242_16102"
        x1="74.5401"
        y1="9.38988"
        x2="69.44"
        y2="11.7717"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2242_16102"
        x1="47.4475"
        y1="26.2174"
        x2="45.7839"
        y2="29.8199"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2242_16102"
        x1="63.9996"
        y1="44.7003"
        x2="57.3789"
        y2="49.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
    </defs>
  </svg>
)

export const renderSystem = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="106"
    viewBox="0 0 120 106"
    fill="none"
  >
    <path
      d="M29.5265 66.6039C29.5588 66.7329 29.5992 66.8699 29.6476 67.015L29.7445 67.4018C29.7768 67.5308 29.793 67.6356 29.793 67.7162C29.793 68.1675 29.6719 68.5665 29.4297 68.913C29.1875 69.2596 28.8726 69.5135 28.4851 69.6747C28.3398 69.6908 28.1864 69.6989 28.0249 69.6989C27.8957 69.715 27.7504 69.723 27.5889 69.723H27.1287L23.3504 69.7714V73.8093C23.3504 74.4057 23.3625 75.0062 23.3868 75.6107C23.411 76.2151 23.4392 76.7592 23.4715 77.2428C23.5038 77.8231 23.5442 78.3792 23.5926 78.9111H20.1049L20.1776 77.9681C20.1937 77.5974 20.2099 77.0936 20.226 76.4569C20.2422 75.8202 20.2503 74.9699 20.2503 73.906V70.2066C19.9758 70.4484 19.669 70.5693 19.3299 70.5693C19.0554 70.5693 18.8172 70.5048 18.6154 70.3759C18.4136 70.2469 18.2481 70.0696 18.1189 69.8439L15.382 69.6989C14.8492 69.5699 14.4052 69.2999 14.0499 68.8889C13.6947 68.4778 13.5171 67.9902 13.5171 67.426C13.5171 67.3293 13.5252 67.2406 13.5413 67.1601C13.5575 67.0795 13.5817 66.9989 13.614 66.9183L14.2195 65.5159C14.2518 65.1612 14.3527 64.8308 14.5222 64.5245C14.6918 64.2183 14.9057 63.9523 15.1641 63.7266L18.9666 56.6905H18.9908C19.2976 56.1263 19.6609 55.6427 20.0807 55.2397C20.5005 54.8367 21.0414 54.6353 21.7035 54.6353C22.2847 54.6353 22.8055 54.7884 23.2657 55.0947C23.7258 55.4009 24.069 55.8039 24.295 56.3036L27.3467 62.2759C27.8957 62.4693 28.3478 62.8078 28.7031 63.2914C29.0583 63.775 29.2359 64.3311 29.2359 64.9597C29.2359 65.2177 29.1955 65.4917 29.1148 65.7818L29.5265 66.6039Z"
      fill="url(#paint0_linear_2242_16340)"
    />
    <path
      d="M115.044 66.6039C115.076 66.7329 115.116 66.8699 115.165 67.015L115.262 67.4018C115.294 67.5308 115.31 67.6356 115.31 67.7162C115.31 68.1675 115.189 68.5665 114.947 68.913C114.705 69.2596 114.39 69.5135 114.002 69.6747C113.857 69.6908 113.703 69.6989 113.542 69.6989C113.413 69.715 113.267 69.723 113.106 69.723H112.646L108.868 69.7714V73.8093C108.868 74.4057 108.88 75.0062 108.904 75.6107C108.928 76.2151 108.956 76.7592 108.989 77.2428C109.021 77.8231 109.061 78.3792 109.11 78.9111H105.622L105.695 77.9681C105.711 77.5974 105.727 77.0936 105.743 76.4569C105.759 75.8202 105.767 74.9699 105.767 73.906V70.2066C105.493 70.4484 105.186 70.5693 104.847 70.5693C104.572 70.5693 104.334 70.5048 104.132 70.3759C103.931 70.2469 103.765 70.0696 103.636 69.8439L100.899 69.6989C100.366 69.5699 99.9222 69.2999 99.567 68.8889C99.2118 68.4778 99.0342 67.9902 99.0342 67.426C99.0342 67.3293 99.0423 67.2406 99.0584 67.1601C99.0745 67.0795 99.0988 66.9989 99.1311 66.9183L99.7366 65.5159C99.7689 65.1612 99.8698 64.8308 100.039 64.5245C100.209 64.2183 100.423 63.9523 100.681 63.7266L104.484 56.6905H104.508C104.815 56.1263 105.178 55.6427 105.598 55.2397C106.018 54.8367 106.559 54.6353 107.221 54.6353C107.802 54.6353 108.323 54.7884 108.783 55.0947C109.243 55.4009 109.586 55.8039 109.812 56.3036L112.864 62.2759C113.413 62.4693 113.865 62.8078 114.22 63.2914C114.575 63.775 114.753 64.3311 114.753 64.9597C114.753 65.2177 114.713 65.4917 114.632 65.7818L115.044 66.6039Z"
      fill="url(#paint1_linear_2242_16340)"
    />
    <path
      d="M104.896 69.2612C104.921 69.3624 104.952 69.4698 104.99 69.5835L105.065 69.8869C105.091 69.988 105.103 70.0701 105.103 70.1333C105.103 70.4872 105.009 70.8001 104.82 71.0718C104.631 71.3435 104.386 71.5426 104.084 71.669C103.97 71.6816 103.851 71.6879 103.725 71.6879C103.624 71.7006 103.511 71.7069 103.385 71.7069H103.026L100.08 71.7448V74.9109C100.08 75.3786 100.09 75.8494 100.109 76.3233C100.127 76.7973 100.149 77.2239 100.175 77.603C100.2 78.0581 100.231 78.4941 100.269 78.9112H97.5499L97.6065 78.1718C97.6191 77.8811 97.6317 77.4861 97.6443 76.9869C97.6569 76.4876 97.6632 75.8209 97.6632 74.9868V72.0861C97.4491 72.2757 97.21 72.3705 96.9456 72.3705C96.7316 72.3705 96.5459 72.3199 96.3885 72.2188C96.2312 72.1177 96.1021 71.9786 96.0014 71.8017L93.8676 71.6879C93.4522 71.5868 93.106 71.3751 92.829 71.0528C92.5521 70.7305 92.4136 70.3482 92.4136 69.9058C92.4136 69.83 92.4199 69.7605 92.4325 69.6973C92.445 69.6341 92.4639 69.5709 92.4891 69.5077L92.9612 68.4081C92.9864 68.13 93.065 67.8709 93.1972 67.6308C93.3294 67.3907 93.4962 67.1821 93.6976 67.0052L96.6623 61.4882H96.6812C96.9204 61.0458 97.2037 60.6667 97.531 60.3507C97.8583 60.0347 98.28 59.8767 98.7962 59.8767C99.2494 59.8767 99.6554 59.9968 100.014 60.2369C100.373 60.4771 100.64 60.793 100.817 61.1849L103.196 65.8676C103.624 66.0193 103.977 66.2847 104.253 66.6639C104.53 67.0431 104.669 67.4791 104.669 67.9721C104.669 68.1743 104.637 68.3891 104.574 68.6166L104.896 69.2612Z"
      fill="url(#paint2_linear_2242_16340)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.3448 72.5664C75.2771 72.5664 90.5248 73.9476 101.183 76.1537C111.607 76.2231 120 79.3455 120 83.1871C120 86.2317 114.728 88.8245 107.351 89.8038C105.591 90.3247 103.609 90.8157 101.432 91.272C101.489 91.5627 101.517 91.8564 101.517 92.1526C101.517 98.8562 86.9433 104.291 68.9655 104.291C52.7912 104.291 39.3721 99.8918 36.8425 94.1275C15.2605 92.4887 0 88.455 0 83.7388C0 77.5685 26.1219 72.5664 58.3448 72.5664Z"
      fill="var(--xzx-brand-1)"
    />
    <path
      d="M64.9655 89.1454C70.2217 89.1454 74.4827 88.0339 74.4827 86.6627C74.4827 85.2915 70.2217 84.1799 64.9655 84.1799C59.7093 84.1799 55.4482 85.2915 55.4482 86.6627C55.4482 88.0339 59.7093 89.1454 64.9655 89.1454Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M102.725 8.37677C102.725 10.0147 101.191 11.325 99.2539 11.325H88.5173C86.5799 11.194 84.9653 9.94918 84.9653 8.24573C84.9653 7.13194 85.6919 6.14918 86.7413 5.62504C86.6606 5.42849 86.5799 5.23194 86.5799 5.03539C86.5799 3.92159 87.6293 2.93884 89.0017 2.93884C89.5667 2.93884 90.0511 3.13539 90.4547 3.39746C91.4235 1.89056 93.1994 0.842285 95.2983 0.842285C98.2045 0.842285 100.546 2.87332 100.546 5.36297V5.62504C101.837 6.08366 102.725 7.13194 102.725 8.37677Z"
      fill="url(#paint3_linear_2242_16340)"
    />
    <path
      d="M38.3446 21.2387C38.3446 23.3939 36.1528 25.1181 33.3841 25.1181H18.0412C15.2725 24.9456 12.9653 23.3077 12.9653 21.0663C12.9653 19.6008 14.0036 18.3077 15.5033 17.6181C15.3879 17.3594 15.2725 17.1008 15.2725 16.8422C15.2725 15.3767 16.7722 14.0836 18.7334 14.0836C19.5409 14.0836 20.233 14.3422 20.8098 14.687C22.1942 12.7043 24.7321 11.325 27.7315 11.325C31.8845 11.325 35.2299 13.9974 35.2299 17.2732V17.6181C37.0757 18.2215 38.3446 19.6008 38.3446 21.2387Z"
      fill="url(#paint4_linear_2242_16340)"
    />
    <path
      d="M52.5796 41.2124C46.7545 44.7425 44.078 48.4826 44.5502 52.4328C45.0223 56.383 45.721 60.163 46.6462 63.7726C47.9926 65.4884 49.5526 65.6888 51.3262 64.374C53.0998 63.0591 55.4733 61.0538 58.4468 58.3581L52.5796 41.2124Z"
      fill="var(--xzx-brand-4)"
    />
    <path
      d="M78.3457 41.2124C84.1708 44.7425 86.8473 48.4826 86.3751 52.4328C85.903 56.383 85.2043 60.163 84.2791 63.7726C82.9327 65.4884 81.3727 65.6888 79.5991 64.374C77.8255 63.0591 75.452 61.0538 72.4785 58.3581L78.3457 41.2124Z"
      fill="var(--xzx-brand-4)"
    />
    <path
      d="M72.9064 60.7223C86.7791 39.843 71.0453 22.0673 66.4636 17.5807C65.8409 16.97 64.726 16.9634 64.0905 17.5648C59.4379 21.9786 43.5055 39.48 57.6378 60.7223H72.9064Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M66.4061 17.5838C65.8129 16.9729 64.7503 16.9608 64.1421 17.561C62.493 19.186 59.3663 22.6021 56.7852 27.378H73.5739C71.0214 22.6597 68.0008 19.2289 66.4061 17.5838Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M72.9203 60.7224C73.4062 60.0195 73.858 59.3191 74.273 58.6238H56.3184C56.7362 59.3191 57.1513 60.0182 57.6385 60.7224H72.9203Z"
      fill={EmptyColors.gray200}
    />
    <path
      d="M73.2653 72.1481C73.1592 72.6072 73.1625 73.0162 72.872 73.3067C72.7586 73.4201 72.6169 73.5193 72.4397 73.5972C71.8055 73.8913 71.2386 73.7709 70.7354 73.3102C70.4166 73.0197 70.1189 72.7079 69.8071 72.4103C69.4351 72.0595 69.3005 71.932 69.1587 72.0737C69.0808 72.1516 69.0028 72.3075 68.8824 72.5485C68.1454 74.0153 67.4155 75.4822 66.6785 76.9491C66.5687 77.1723 66.4376 77.3813 66.2746 77.5443C66.1187 77.7002 65.9274 77.8207 65.6865 77.8915C64.9495 78.097 64.3011 77.803 63.9113 77.0376C63.146 75.5424 62.4055 74.0295 61.6473 72.5272C61.3213 71.8753 61.3 71.8753 60.7615 72.3926C60.439 72.7079 60.1237 73.0303 59.7906 73.3351C59.3052 73.7779 58.749 73.8807 58.136 73.615C57.5407 73.3528 57.4735 72.8409 57.2715 72.2473C56.237 69.2073 57.1883 65.1264 57.2715 64.6902C57.3405 64.3283 57.3778 63.9887 57.6152 63.7513C57.64 63.7265 57.6648 63.7017 57.6896 63.684C58.2529 63.1348 58.8092 63.0746 59.5781 63.4395C62.5933 64.8887 65.7077 65.1544 68.9213 64.2367C69.63 64.0312 70.3138 63.7584 70.9799 63.4324C72.181 62.8407 73.2582 64.2367 73.2582 64.8391C73.8302 66.9221 74.1917 68.1377 73.2653 72.1481Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M57.6392 60.7224H72.8746V62.821H57.6392V60.7224Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M65.2102 45.0993C69.0736 45.0993 72.2055 41.9674 72.2055 38.104C72.2055 34.2406 69.0736 31.1086 65.2102 31.1086C61.3468 31.1086 58.2148 34.2406 58.2148 38.104C58.2148 41.9674 61.3468 45.0993 65.2102 45.0993Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M65.2109 42.7678C67.7865 42.7678 69.8745 40.6798 69.8745 38.1042C69.8745 35.5286 67.7865 33.4407 65.2109 33.4407C62.6353 33.4407 60.5474 35.5286 60.5474 38.1042C60.5474 40.6798 62.6353 42.7678 65.2109 42.7678Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M65.0738 52.0947C65.0738 52.0947 59.0398 56.9469 65.0395 69.583C71.1066 57.0815 65.0738 52.0947 65.0738 52.0947Z"
      fill="var(--xzx-brand-4)"
    />
    <path
      d="M39.9252 60.142L46.6887 71.7367C46.8423 71.9999 46.7534 72.3377 46.4902 72.4912C46.4058 72.5405 46.3098 72.5664 46.2122 72.5664H32.685C32.3803 72.5664 32.1333 72.3194 32.1333 72.0147C32.1333 71.917 32.1592 71.821 32.2085 71.7367L38.972 60.142C39.1256 59.8788 39.4634 59.7899 39.7266 59.9434C39.8088 59.9914 39.8772 60.0598 39.9252 60.142Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M40.2763 69.8079H38.6211V87.463H40.2763V69.8079Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M40 68.2215C39.9311 68.4284 39.7931 68.5664 39.5862 68.5664C39.3793 68.5664 39.2414 68.4284 39.1724 68.2215L38.8966 64.4284C38.8966 64.0146 39.2414 63.7388 39.5862 63.7388C40 63.7388 40.2759 64.0836 40.2759 64.4974L40 68.2215ZM39.5862 69.256C40 69.256 40.2759 69.5319 40.2759 69.9457C40.2759 70.3595 40 70.6353 39.5862 70.6353C39.1724 70.6353 38.8966 70.3595 38.8966 69.9457C38.8966 69.5319 39.1724 69.256 39.5862 69.256Z"
      fill="var(--xzx-brand-2)"
    />
    <g opacity="0.2">
      <path
        d="M62.5115 100.248L49.9484 99.6151C49.6441 99.5997 49.4098 99.3406 49.4252 99.0363C49.4292 98.9554 49.4511 98.8765 49.4891 98.805L54.502 89.377C54.6451 89.108 54.9791 89.0058 55.2482 89.1489C55.3196 89.1869 55.3819 89.2401 55.4305 89.3049L62.9805 99.366C63.1634 99.6098 63.1141 99.9556 62.8704 100.138C62.7672 100.216 62.6402 100.255 62.5115 100.248Z"
        fill="var(--xzx-brand-3)"
      />
      <path
        d="M54.3485 95.8177L54.9961 94.5999L39.4075 86.3113L38.76 87.5291L54.3485 95.8177Z"
        fill="var(--xzx-brand-3)"
      />
      <path
        d="M55.8936 96.4306C55.7368 96.2847 55.6669 96.1226 55.7446 95.9764C55.8223 95.8303 55.9959 95.7976 56.2044 95.846L59.6572 97.4319C60.0225 97.6262 60.1366 97.9993 60.0071 98.2428C59.8517 98.5351 59.4436 98.5681 59.0782 98.3738L55.8936 96.4306ZM55.1356 95.6526C54.9802 95.9449 54.633 96.0103 54.2677 95.816C53.9023 95.6218 53.7624 95.2974 53.9178 95.0051C54.0732 94.7128 54.4204 94.6475 54.7857 94.8417C55.1511 95.036 55.291 95.3604 55.1356 95.6526Z"
        fill="var(--xzx-brand-2)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2242_16340"
        x1="29.793"
        y1="66.7732"
        x2="13.5171"
        y2="66.7732"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2242_16340"
        x1="115.31"
        y1="66.7732"
        x2="99.0342"
        y2="66.7732"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2242_16340"
        x1="105.103"
        y1="69.394"
        x2="92.4136"
        y2="69.394"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2242_16340"
        x1="102.725"
        y1="6.08366"
        x2="84.9653"
        y2="6.08366"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2242_16340"
        x1="38.3446"
        y1="18.2215"
        x2="12.9653"
        y2="18.2215"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
    </defs>
  </svg>
)

export const renderNetwork = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="104"
    viewBox="0 0 120 104"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.3448 71.9136C75.2771 71.9136 90.5248 73.2948 101.183 75.5009C111.607 75.5702 120 78.6926 120 82.5343C120 85.5788 114.728 88.1717 107.351 89.151C105.591 89.6719 103.609 90.1629 101.432 90.6192C101.489 90.9099 101.517 91.2036 101.517 91.4998C101.517 98.2034 86.9433 103.638 68.9655 103.638C52.7912 103.638 39.3721 99.239 36.8425 93.4747C15.2605 91.8359 0 87.8022 0 83.086C0 76.9156 26.1219 71.9136 58.3448 71.9136Z"
      fill="var(--xzx-brand-1)"
    />
    <path
      d="M62.2067 88.4926C67.4629 88.4926 71.7239 87.381 71.7239 86.0099C71.7239 84.6387 67.4629 83.5271 62.2067 83.5271C56.9505 83.5271 52.6895 84.6387 52.6895 86.0099C52.6895 87.381 56.9505 88.4926 62.2067 88.4926Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M107.672 67.9322C107.695 68.0231 107.724 68.1196 107.759 68.2218L107.828 68.4944C107.851 68.5853 107.862 68.6591 107.862 68.7159C107.862 69.0338 107.776 69.3149 107.603 69.5591C107.431 69.8033 107.207 69.9821 106.931 70.0957C106.828 70.1071 106.718 70.1128 106.603 70.1128C106.512 70.1241 106.408 70.1298 106.293 70.1298H105.966L103.276 70.1639V73.0088C103.276 73.429 103.284 73.852 103.302 74.2779C103.319 74.7038 103.339 75.0871 103.362 75.4278C103.385 75.8366 103.414 76.2284 103.448 76.6032H100.966L101.017 75.9388C101.029 75.6776 101.04 75.3227 101.052 74.8741C101.063 74.4255 101.069 73.8264 101.069 73.0769V70.4705C100.874 70.6408 100.655 70.726 100.414 70.726C100.218 70.726 100.049 70.6806 99.9052 70.5897C99.7615 70.4989 99.6437 70.374 99.5517 70.215L97.6035 70.1128C97.2242 70.0219 96.9081 69.8317 96.6552 69.5421C96.4023 69.2525 96.2759 68.9089 96.2759 68.5114C96.2759 68.4433 96.2816 68.3808 96.2931 68.324C96.3046 68.2673 96.3219 68.2105 96.3448 68.1537L96.7759 67.1656C96.7989 66.9158 96.8707 66.683 96.9914 66.4672C97.1121 66.2514 97.2644 66.064 97.4483 65.905L100.155 60.9478H100.172C100.391 60.5503 100.649 60.2096 100.948 59.9256C101.247 59.6417 101.632 59.4998 102.103 59.4998C102.517 59.4998 102.888 59.6076 103.216 59.8234C103.543 60.0392 103.787 60.3231 103.948 60.6752L106.121 64.8829C106.512 65.0192 106.833 65.2577 107.086 65.5984C107.339 65.9391 107.466 66.3309 107.466 66.7738C107.466 66.9555 107.437 67.1486 107.379 67.353L107.672 67.9322Z"
      fill="url(#paint0_linear_2242_16371)"
    />
    <path
      d="M118.707 73.4496C118.73 73.5404 118.759 73.637 118.793 73.7392L118.862 74.0117C118.885 74.1026 118.897 74.1764 118.897 74.2332C118.897 74.5512 118.811 74.8323 118.638 75.0764C118.466 75.3206 118.242 75.4995 117.966 75.6131C117.862 75.6244 117.753 75.6301 117.638 75.6301C117.546 75.6414 117.443 75.6471 117.328 75.6471H117L114.311 75.6812V78.5261C114.311 78.9463 114.319 79.3693 114.336 79.7952C114.354 80.2211 114.374 80.6044 114.397 80.9451C114.42 81.3539 114.448 81.7458 114.483 82.1205H112L112.052 81.4562C112.063 81.195 112.075 80.8401 112.086 80.3915C112.098 79.9429 112.104 79.3438 112.104 78.5942V75.9878C111.908 76.1582 111.69 76.2434 111.448 76.2434C111.253 76.2434 111.084 76.1979 110.94 76.1071C110.796 76.0162 110.678 75.8913 110.586 75.7323L108.638 75.6301C108.259 75.5392 107.943 75.349 107.69 75.0594C107.437 74.7698 107.311 74.4263 107.311 74.0288C107.311 73.9606 107.316 73.8982 107.328 73.8414C107.339 73.7846 107.357 73.7278 107.38 73.671L107.811 72.683C107.834 72.4331 107.905 72.2003 108.026 71.9845C108.147 71.7688 108.299 71.5814 108.483 71.4224L111.19 66.4651H111.207C111.425 66.0676 111.684 65.7269 111.983 65.443C112.282 65.1591 112.667 65.0171 113.138 65.0171C113.552 65.0171 113.923 65.125 114.25 65.3408C114.578 65.5565 114.822 65.8405 114.983 66.1925L117.155 70.4002C117.546 70.5365 117.868 70.775 118.121 71.1157C118.374 71.4564 118.5 71.8482 118.5 72.2912C118.5 72.4729 118.471 72.6659 118.414 72.8704L118.707 73.4496Z"
      fill="url(#paint1_linear_2242_16371)"
    />
    <path
      d="M21.2507 71.4684C21.2829 71.5974 21.3233 71.7344 21.3718 71.8795L21.4686 72.2663C21.5009 72.3953 21.5171 72.5001 21.5171 72.5807C21.5171 73.032 21.396 73.431 21.1538 73.7775C20.9116 74.1241 20.5967 74.378 20.2092 74.5392C20.0639 74.5553 19.9105 74.5634 19.749 74.5634C19.6198 74.5795 19.4745 74.5875 19.3131 74.5875H18.8529L15.0745 74.6359V78.6738C15.0745 79.2702 15.0867 79.8707 15.1109 80.4752C15.1351 81.0796 15.1634 81.6237 15.1956 82.1073C15.2279 82.6876 15.2683 83.2437 15.3167 83.7756H11.8291L11.9017 82.8326C11.9179 82.4619 11.934 81.9582 11.9502 81.3214C11.9663 80.6847 11.9744 79.8344 11.9744 78.7705V75.0711C11.6999 75.3129 11.3931 75.4338 11.054 75.4338C10.7795 75.4338 10.5414 75.3693 10.3395 75.2404C10.1377 75.1114 9.97219 74.9341 9.84302 74.7084L7.10615 74.5634C6.57331 74.4344 6.12928 74.1644 5.77405 73.7534C5.41882 73.3423 5.24121 72.8547 5.24121 72.2905C5.24121 72.1938 5.24928 72.1052 5.26543 72.0246C5.28158 71.944 5.3058 71.8634 5.33809 71.7828L5.94359 70.3804C5.97589 70.0257 6.0768 69.6953 6.24634 69.389C6.41588 69.0828 6.62983 68.8168 6.88817 68.5911L10.6907 61.555H10.7149C11.0217 60.9908 11.385 60.5072 11.8048 60.1042C12.2247 59.7012 12.7656 59.4998 13.4276 59.4998C14.0089 59.4998 14.5296 59.6529 14.9898 59.9592C15.45 60.2654 15.7931 60.6684 16.0191 61.1681L19.0708 67.1404C19.6198 67.3338 20.0719 67.6723 20.4272 68.1559C20.7824 68.6395 20.96 69.1956 20.96 69.8243C20.96 70.0822 20.9196 70.3562 20.8389 70.6463L21.2507 71.4684Z"
      fill="url(#paint2_linear_2242_16371)"
    />
    <path
      d="M11.8972 24.1807H13.9141C13.9141 20.1433 17.187 16.8704 21.2244 16.8704C25.2618 16.8704 28.5348 20.1433 28.5348 24.1807H30.008C31.8654 24.1807 33.3711 25.8173 33.3711 27.836C33.3711 29.8546 31.8653 31.4911 30.008 31.4911H11.8971C10.0395 31.4911 8.53394 29.8545 8.53394 27.836C8.53394 25.8172 10.0396 24.1807 11.8972 24.1807Z"
      fill="url(#paint3_linear_2242_16371)"
    />
    <path
      d="M75.6714 5.60384H77.1176C77.1176 2.70902 79.4642 0.362549 82.359 0.362549C85.254 0.362549 87.6007 2.70902 87.6007 5.60384H88.657C89.9887 5.60384 91.0684 6.77742 91.0684 8.22475C91.0684 9.67207 89.9887 10.8453 88.657 10.8453H75.6714C74.3396 10.8453 73.2601 9.67207 73.2601 8.22475C73.2601 6.77742 74.3396 5.60384 75.6714 5.60384Z"
      fill="url(#paint4_linear_2242_16371)"
    />
    <path
      d="M74.545 49.1189H57.7877C56.7722 49.1189 56.2645 49.6268 56.2645 50.6425C56.2645 51.658 56.7722 52.1658 57.7877 52.1658H74.545C75.5605 52.1658 76.0684 51.658 76.0684 50.6425C76.0684 49.6266 75.5605 49.1189 74.545 49.1189Z"
      fill="white"
    />
    <path
      d="M74.545 56.7361H62.3577C61.3425 56.7361 60.8343 57.2439 60.8343 58.2593C60.8343 59.2748 61.3425 59.7829 62.3577 59.7829H74.545C75.5605 59.7829 76.0684 59.2748 76.0684 58.2593C76.0684 57.2439 75.5605 56.7361 74.545 56.7361Z"
      fill="white"
    />
    <path
      d="M61.3954 76.7616C49.5038 76.7616 39.8636 67.1215 39.8636 55.2298C39.8636 43.3381 49.5038 33.698 61.3954 33.698C73.2871 33.698 82.9272 43.3381 82.9272 55.2298C82.9272 67.1215 73.2871 76.7616 61.3954 76.7616Z"
      fill="url(#paint5_linear_2242_16371)"
    />
    <path
      d="M55.1966 44.1465C52.8462 44.8681 50.6379 44.4664 50.2642 43.2493C49.8905 42.0322 51.493 40.4606 53.8434 39.739C56.1938 39.0174 58.402 39.419 58.7757 40.6361C59.1494 41.8532 57.5469 43.4249 55.1966 44.1465Z"
      fill="var(--xzx-brand-1)"
    />
    <path
      d="M65.5637 56.2363C62.9537 56.2363 60.8379 54.1205 60.8379 51.5105C60.8379 48.9005 62.9537 46.7847 65.5637 46.7847C68.1737 46.7847 70.2896 48.9005 70.2896 51.5105C70.2896 54.1205 68.1737 56.2363 65.5637 56.2363Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M74.2889 46.1302C73.6394 45.4521 73.4629 44.5673 73.8945 44.1539C74.3262 43.7405 75.2025 43.9551 75.852 44.6331C76.5014 45.3112 76.6779 46.196 76.2463 46.6094C75.8146 47.0228 74.9383 46.8083 74.2889 46.1302Z"
      fill="var(--xzx-brand-1)"
    />
    <path
      d="M40.195 58.9563C40.2368 59.2072 40.4067 60.0299 40.4574 60.2776C36.735 62.7744 35.0321 64.9908 35.5535 66.2083C37.0144 69.9377 51.7734 68.3727 64.8452 64.1969C77.917 60.0211 91.0153 52.5157 89.3912 49.1189C88.1476 47.3165 83.6017 47.3581 81.4447 47.3581C81.3426 47.1245 80.957 46.2931 80.8471 46.064C86.4495 45.8635 90.254 46.8159 90.9224 48.9671C92.2531 53.2495 80.6571 60.6594 65.0218 65.5177C49.3868 70.376 35.6332 70.8425 34.3026 66.5601C33.6714 64.5276 35.9532 61.7905 40.195 58.9563Z"
      fill="url(#paint6_linear_2242_16371)"
    />
    <path
      d="M45.7347 63.0975C44.2705 63.0975 43.0836 61.9106 43.0836 60.4465C43.0836 58.9823 44.2705 57.7954 45.7347 57.7954C47.1988 57.7954 48.3857 58.9823 48.3857 60.4465C48.3857 61.9106 47.1988 63.0975 45.7347 63.0975Z"
      fill="var(--xzx-brand-4)"
    />
    <path
      d="M61.9864 63.7889C61.0952 63.7889 60.3727 63.0664 60.3727 62.1752C60.3727 61.284 61.0952 60.5615 61.9864 60.5615C62.8776 60.5615 63.6001 61.284 63.6001 62.1752C63.6001 63.0664 62.8776 63.7889 61.9864 63.7889Z"
      fill="var(--xzx-brand-4)"
    />
    <path
      d="M84.0727 33.0568L85.487 31.6426L86.1892 32.3448C87.383 33.5386 89.2151 33.5323 90.4172 32.3302L91.1243 31.6231C92.3264 30.421 92.3327 28.5889 91.1389 27.3951C89.9451 26.2013 88.113 26.2076 86.9109 27.4097L86.2038 28.1168L84.7994 26.7124L85.5065 26.0053C87.4864 24.0254 90.5869 24.0146 92.5531 25.9809C94.5194 27.9471 94.5087 31.0477 92.5288 33.0276L91.8217 33.7347C90.1246 35.4317 87.5166 35.6521 85.5479 34.3906L84.063 35.8755L82.6585 34.471L84.0727 33.0568ZM81.9514 35.1781L83.3559 36.5826L81.9417 37.9968L80.5372 36.5924L81.9514 35.1781Z"
      fill="url(#paint7_linear_2242_16371)"
    />
    <path
      d="M73.7794 26.9296L74.1542 25.5306L74.847 25.7163C76.0248 26.0319 77.1691 25.3639 77.4877 24.1748L77.6751 23.4753C77.9938 22.2862 77.3368 21.1356 76.159 20.82C74.9812 20.5044 73.8369 21.1724 73.5183 22.3615L73.3309 23.061L71.9453 22.6897L72.1327 21.9902C72.6575 20.0317 74.594 18.9013 76.5338 19.4211C78.4737 19.9409 79.5855 21.8881 79.0607 23.8466L78.8733 24.5461C78.4235 26.2248 76.8709 27.3081 75.1838 27.2309L74.7902 28.6998L73.4046 28.3285L73.7794 26.9296ZM73.2171 29.028L74.6027 29.3992L74.2279 30.7982L72.8423 30.4269L73.2171 29.028Z"
      fill="url(#paint8_linear_2242_16371)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2242_16371"
        x1="107.862"
        y1="68.0515"
        x2="96.2759"
        y2="68.0515"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2242_16371"
        x1="118.897"
        y1="73.5688"
        x2="107.311"
        y2="73.5688"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2242_16371"
        x1="21.5171"
        y1="71.6377"
        x2="5.24121"
        y2="71.6377"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2242_16371"
        x1="8.53394"
        y1="24.1807"
        x2="33.3711"
        y2="24.1807"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2242_16371"
        x1="73.2601"
        y1="5.60393"
        x2="91.0684"
        y2="5.60393"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2242_16371"
        x1="61.3954"
        y1="76.7616"
        x2="61.3954"
        y2="33.698"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-4)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2242_16371"
        x1="34.2063"
        y1="66.3961"
        x2="90.7581"
        y2="49.0168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-4)" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2242_16371"
        x1="81.1034"
        y1="37.1548"
        x2="92.1379"
        y2="25.8445"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-5)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2242_16371"
        x1="73.3791"
        y1="30.8097"
        x2="76.4136"
        y2="19.4994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-5)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
    </defs>
  </svg>
)

export const renderNotFound = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="106"
    viewBox="0 0 120 106"
    fill="none"
  >
    <path
      d="M30.0086 25.1807H27.9916C27.9916 21.1433 24.7187 17.8704 20.6813 17.8704C16.644 17.8704 13.3709 21.1433 13.3709 25.1807H11.8977C10.0403 25.1807 8.53467 26.8173 8.53467 28.836C8.53467 30.8546 10.0404 32.4911 11.8977 32.4911H30.0087C31.8663 32.4911 33.3718 30.8545 33.3718 28.836C33.3718 26.8172 31.8662 25.1807 30.0086 25.1807Z"
      fill="url(#paint0_linear_2242_16398)"
    />
    <path
      d="M102.318 31.4315H100.872C100.872 28.5367 98.5255 26.1902 95.6307 26.1902C92.7357 26.1902 90.3891 28.5367 90.3891 31.4315H89.3327C88.0011 31.4315 86.9214 32.6051 86.9214 34.0524C86.9214 35.4997 88.0011 36.6729 89.3327 36.6729H102.318C103.65 36.6729 104.73 35.4997 104.73 34.0524C104.73 32.6051 103.65 31.4315 102.318 31.4315Z"
      fill="url(#paint1_linear_2242_16398)"
    />
    <path
      d="M75.8977 32.9048H77.9146C77.9146 28.8674 81.1875 25.5945 85.2249 25.5945C89.2623 25.5945 92.5353 28.8674 92.5353 32.9048H94.0085C95.8659 32.9048 97.3716 34.5414 97.3716 36.5601C97.3716 38.5788 95.8658 40.2152 94.0085 40.2152H75.8976C74.04 40.2152 72.5344 38.5787 72.5344 36.5601C72.5344 34.5413 74.0401 32.9048 75.8977 32.9048Z"
      fill="url(#paint2_linear_2242_16398)"
    />
    <path
      d="M81.6284 5.50032H80.1822C80.1822 2.6055 77.8356 0.259033 74.9408 0.259033C72.0458 0.259033 69.6991 2.6055 69.6991 5.50032H68.6428C67.3111 5.50032 66.2314 6.67391 66.2314 8.12123C66.2314 9.56856 67.3111 10.7418 68.6428 10.7418H81.6284C82.9602 10.7418 84.0397 9.56856 84.0397 8.12123C84.0397 6.67391 82.9602 5.50032 81.6284 5.50032Z"
      fill="url(#paint3_linear_2242_16398)"
    />
    <path
      d="M107.672 70.0357C107.695 70.1266 107.724 70.2231 107.759 70.3253L107.828 70.5979C107.851 70.6888 107.862 70.7626 107.862 70.8194C107.862 71.1374 107.776 71.4184 107.603 71.6626C107.431 71.9068 107.207 72.0857 106.931 72.1992C106.828 72.2106 106.718 72.2163 106.603 72.2163C106.512 72.2276 106.408 72.2333 106.293 72.2333H105.966L103.276 72.2674V75.1123C103.276 75.5325 103.284 75.9555 103.302 76.3814C103.319 76.8073 103.339 77.1906 103.362 77.5313C103.385 77.9401 103.414 78.3319 103.448 78.7067H100.966L101.017 78.0423C101.029 77.7811 101.04 77.4262 101.052 76.9776C101.063 76.529 101.069 75.93 101.069 75.1804V72.574C100.874 72.7444 100.655 72.8295 100.414 72.8295C100.218 72.8295 100.049 72.7841 99.9052 72.6933C99.7615 72.6024 99.6437 72.4775 99.5517 72.3185L97.6035 72.2163C97.2242 72.1254 96.9081 71.9352 96.6552 71.6456C96.4023 71.356 96.2759 71.0124 96.2759 70.6149C96.2759 70.5468 96.2816 70.4843 96.2931 70.4276C96.3046 70.3708 96.3219 70.314 96.3448 70.2572L96.7759 69.2692C96.7989 69.0193 96.8707 68.7865 96.9914 68.5707C97.1121 68.3549 97.2644 68.1675 97.4483 68.0085L100.155 63.0513H100.172C100.391 62.6538 100.649 62.3131 100.948 62.0292C101.247 61.7452 101.632 61.6033 102.103 61.6033C102.517 61.6033 102.888 61.7112 103.216 61.9269C103.543 62.1427 103.787 62.4266 103.948 62.7787L106.121 66.9864C106.512 67.1227 106.833 67.3612 107.086 67.7019C107.339 68.0426 107.466 68.4344 107.466 68.8773C107.466 69.0591 107.437 69.2521 107.379 69.4565L107.672 70.0357Z"
      fill="url(#paint4_linear_2242_16398)"
    />
    <path
      d="M118.707 75.5528C118.73 75.6437 118.759 75.7402 118.793 75.8424L118.862 76.115C118.885 76.2059 118.897 76.2797 118.897 76.3365C118.897 76.6545 118.811 76.9355 118.638 77.1797C118.466 77.4239 118.242 77.6028 117.966 77.7163C117.862 77.7277 117.753 77.7334 117.638 77.7334C117.546 77.7447 117.443 77.7504 117.328 77.7504H117L114.311 77.7845V80.6294C114.311 81.0496 114.319 81.4726 114.336 81.8985C114.354 82.3244 114.374 82.7077 114.397 83.0484C114.42 83.4572 114.448 83.849 114.483 84.2238H112L112.052 83.5594C112.063 83.2982 112.075 82.9433 112.086 82.4947C112.098 82.0461 112.104 81.4471 112.104 80.6975V78.0911C111.908 78.2615 111.69 78.3466 111.448 78.3466C111.253 78.3466 111.084 78.3012 110.94 78.2103C110.796 78.1195 110.678 77.9946 110.586 77.8356L108.638 77.7334C108.259 77.6425 107.943 77.4523 107.69 77.1627C107.437 76.8731 107.311 76.5295 107.311 76.132C107.311 76.0639 107.316 76.0014 107.328 75.9447C107.339 75.8879 107.357 75.8311 107.38 75.7743L107.811 74.7862C107.834 74.5364 107.905 74.3036 108.026 74.0878C108.147 73.872 108.299 73.6846 108.483 73.5256L111.19 68.5684H111.207C111.425 68.1709 111.684 67.8302 111.983 67.5462C112.282 67.2623 112.667 67.1204 113.138 67.1204C113.552 67.1204 113.923 67.2283 114.25 67.444C114.578 67.6598 114.822 67.9437 114.983 68.2958L117.155 72.5035C117.546 72.6398 117.868 72.8783 118.121 73.219C118.374 73.5597 118.5 73.9515 118.5 74.3944C118.5 74.5761 118.471 74.7692 118.414 74.9736L118.707 75.5528Z"
      fill="url(#paint5_linear_2242_16398)"
    />
    <path
      d="M21.2507 73.5719C21.2829 73.7009 21.3233 73.8379 21.3718 73.983L21.4686 74.3699C21.5009 74.4988 21.5171 74.6036 21.5171 74.6842C21.5171 75.1355 21.396 75.5345 21.1538 75.8811C20.9116 76.2276 20.5967 76.4815 20.2092 76.6427C20.0639 76.6588 19.9105 76.6669 19.749 76.6669C19.6198 76.683 19.4745 76.6911 19.3131 76.6911H18.8529L15.0745 76.7394V80.7773C15.0745 81.3738 15.0867 81.9742 15.1109 82.5787C15.1351 83.1832 15.1634 83.7272 15.1956 84.2108C15.2279 84.7911 15.2683 85.3472 15.3167 85.8791H11.8291L11.9017 84.9361C11.9179 84.5654 11.934 84.0617 11.9502 83.4249C11.9663 82.7882 11.9744 81.9379 11.9744 80.8741V77.1746C11.6999 77.4164 11.3931 77.5373 11.054 77.5373C10.7795 77.5373 10.5414 77.4729 10.3395 77.3439C10.1377 77.2149 9.97219 77.0376 9.84302 76.812L7.10615 76.6669C6.57331 76.5379 6.12928 76.2679 5.77405 75.8569C5.41882 75.4458 5.24121 74.9582 5.24121 74.394C5.24121 74.2973 5.24928 74.2087 5.26543 74.1281C5.28158 74.0475 5.3058 73.9669 5.33809 73.8863L5.94359 72.4839C5.97589 72.1293 6.0768 71.7988 6.24634 71.4925C6.41588 71.1863 6.62983 70.9203 6.88817 70.6946L10.6907 63.6585H10.7149C11.0217 63.0943 11.385 62.6107 11.8048 62.2078C12.2247 61.8048 12.7656 61.6033 13.4276 61.6033C14.0089 61.6033 14.5296 61.7564 14.9898 62.0627C15.45 62.3689 15.7931 62.7719 16.0191 63.2716L19.0708 69.2439C19.6198 69.4373 20.0719 69.7758 20.4272 70.2594C20.7824 70.743 20.96 71.2991 20.96 71.9278C20.96 72.1857 20.9196 72.4597 20.8389 72.7499L21.2507 73.5719Z"
      fill="url(#paint6_linear_2242_16398)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.3448 74.0171C75.2771 74.0171 90.5248 75.3983 101.183 77.6044C111.607 77.6738 120 80.7961 120 84.6378C120 87.6824 114.728 90.2752 107.351 91.2545C105.591 91.7754 103.609 92.2664 101.432 92.7227C101.489 93.0134 101.517 93.3071 101.517 93.6033C101.517 100.307 86.9433 105.741 68.9655 105.741C52.7912 105.741 39.3721 101.343 36.8425 95.5782C15.2605 93.9394 0 89.9057 0 85.1895C0 79.0191 26.1219 74.0171 58.3448 74.0171Z"
      fill="var(--xzx-brand-1)"
    />
    <mask
      id="mask0_2242_16398"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="74"
      width="120"
      height="32"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.3448 74.0171C75.2771 74.0171 90.5248 75.3983 101.183 77.6044C111.607 77.6738 120 80.7961 120 84.6378C120 87.6824 114.728 90.2752 107.351 91.2545C105.591 91.7754 103.609 92.2664 101.432 92.7227C101.489 93.0134 101.517 93.3071 101.517 93.6033C101.517 100.307 86.9433 105.741 68.9655 105.741C52.7912 105.741 39.3721 101.343 36.8425 95.5782C15.2605 93.9394 0 89.9057 0 85.1895C0 79.0191 26.1219 74.0171 58.3448 74.0171Z"
        fill="var(--xzx-brand-1)"
      />
    </mask>
    <g mask="url(#mask0_2242_16398)">
      <path
        d="M27.4697 88.2481L86.9488 118.982L122.22 102.56L47.1064 85.0042L27.4697 88.2481Z"
        fill="url(#paint7_linear_2242_16398)"
      />
      <path
        d="M69.9526 85.4895L135.507 107.27L140.459 89.3132L89.5893 82.2456L69.9526 85.4895Z"
        fill="url(#paint8_linear_2242_16398)"
      />
      <path
        d="M54.5044 82.4551L120.072 109.853L120.543 98.2438L64.6637 81.0984L54.5044 82.4551Z"
        fill="url(#paint9_linear_2242_16398)"
      />
    </g>
    <path
      d="M37.4172 83.5531L37.4129 85.7626L42.6439 85.705L42.6389 90.0545L36.6592 90.1188L36.659 88.2454L27.0405 88.2557V83.566L37.4172 83.5531ZM45.8333 83.4211V87.8349L43.0802 87.8529V83.4391L45.8333 83.4211ZM39.3976 75.9861L39.7246 81.741L30.6383 81.3163L39.3976 75.9861Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M42.6445 85.7036V89.8505L43.077 88.2137L43.0803 83.4395L42.6445 85.7036Z"
      fill="#AFB7C3"
    />
    <path
      d="M45.8342 83.4202L46.2814 81.1353L46.2857 86.2165L45.833 87.8477L45.8342 83.4202Z"
      fill="#AFB7C3"
    />
    <path
      d="M42.6445 85.7035L43.0803 83.4394L45.8343 83.4201L46.2815 81.1109L43.5275 81.1157L44.7086 74.9788L38.8413 74.9077L27.5168 80.9586L27.0352 83.5517L37.0933 83.4813L36.6575 85.776L42.6445 85.7035ZM37.5405 81.1262L32.3917 81.1352L38.1712 77.8049L37.5405 81.1262Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M55.9184 81.3128C56.5324 81.5592 57.0268 81.7274 57.4015 81.8176C57.535 81.8534 57.9003 81.9308 58.4973 82.0499C59.0944 82.169 59.558 82.2421 59.8882 82.2692C60.2184 82.2963 60.5664 82.295 60.9323 82.2652C61.2982 82.2354 61.6569 82.1755 62.0082 82.0856C62.3595 81.9957 62.6578 81.8941 62.9029 81.7808C63.148 81.6675 63.4224 81.4828 63.7263 81.2268C64.0301 80.9707 64.3355 80.5847 64.6425 80.0687C64.9495 79.5527 65.17 79.1209 65.304 78.7734C65.438 78.4258 65.6022 77.8894 65.7965 77.1643L67.8558 69.4788C67.9453 69.1448 68.0172 68.7908 68.0714 68.4167C68.1256 68.0427 68.151 67.7094 68.1475 67.4171C68.144 67.1247 68.1112 66.7989 68.0489 66.4396C67.9867 66.0803 67.843 65.6814 67.618 65.2427C67.393 64.804 67.1572 64.4341 66.9107 64.1328C66.6641 63.8315 66.3848 63.5573 66.0727 63.31C65.7606 63.0628 65.3892 62.8457 64.9587 62.6587C64.5282 62.4718 63.992 62.2974 63.3501 62.1357L62.1689 61.8498C61.3502 61.6612 60.7305 61.5411 60.3096 61.4897C59.8888 61.4383 59.4321 61.454 58.9395 61.5367C58.4469 61.6195 57.9976 61.7599 57.5918 61.9579C57.1859 62.156 56.8541 62.3637 56.5965 62.581C56.3389 62.7983 56.0869 63.0324 55.8407 63.2835C55.5945 63.5345 55.3658 63.844 55.1548 64.2118C54.9437 64.5796 54.7163 65.1041 54.4724 65.7853L52.3786 73.5996C52.2533 74.0672 52.1606 74.5179 52.1006 74.9517C52.0406 75.3856 52.0111 75.8967 52.0119 76.4849C52.0128 77.0732 52.1124 77.5984 52.3107 78.0606C52.509 78.5228 52.7158 78.9054 52.9311 79.2086C53.1465 79.5117 53.4142 79.8007 53.7342 80.0757C54.0543 80.3506 54.3448 80.564 54.6058 80.7157C54.8668 80.8675 55.3043 81.0665 55.9184 81.3128ZM58.9603 77.6028L58.7886 77.5568C58.1875 77.3957 57.7482 77.1936 57.4708 76.9506C57.1933 76.7075 56.9775 76.3965 56.8233 76.0178C56.6692 75.639 56.6229 75.2201 56.6845 74.7611C56.7462 74.3021 56.8511 73.7959 56.9994 73.2425L58.3426 68.1722C58.553 67.3491 58.768 66.8136 58.9879 66.5657C59.2077 66.3178 59.3981 66.1413 59.5592 66.0362C59.7203 65.9311 59.9643 65.8507 60.2911 65.7951C60.6179 65.7395 60.8863 65.7399 61.0962 65.7961L61.7221 65.9792C62.1558 66.1158 62.517 66.2944 62.8057 66.5149C63.0943 66.7354 63.2932 66.9472 63.4024 67.1503C63.5116 67.3535 63.552 67.7273 63.5237 68.272C63.4953 68.8166 63.4185 69.3227 63.2933 69.7902L61.9894 74.6562C61.9485 74.8089 61.8181 75.1907 61.5982 75.8016C61.3782 76.4125 61.1771 76.829 60.9949 77.0512C60.8126 77.2733 60.5282 77.4477 60.1415 77.5741C59.7548 77.7006 59.3611 77.7102 58.9603 77.6028Z"
      fill="#C5B0B0"
    />
    <path
      d="M55.9184 81.3128C56.5324 81.5592 57.0268 81.7274 57.4015 81.8176C57.535 81.8534 57.9003 81.9308 58.4973 82.0499C59.0944 82.169 59.558 82.2421 59.8882 82.2692C60.2184 82.2963 60.5664 82.295 60.9323 82.2652C61.2982 82.2354 61.6569 82.1755 62.0082 82.0856C62.3595 81.9957 62.6578 81.8941 62.9029 81.7808C63.148 81.6675 63.4224 81.4828 63.7263 81.2268C64.0301 80.9707 64.3355 80.5847 64.6425 80.0687C64.9495 79.5527 65.17 79.1209 65.304 78.7734C65.438 78.4258 65.6022 77.8894 65.7965 77.1643L67.8558 69.4788C67.9453 69.1448 68.0172 68.7908 68.0714 68.4167C68.1256 68.0427 68.151 67.7094 68.1475 67.4171C68.144 67.1247 68.1112 66.7989 68.0489 66.4396C67.9867 66.0803 67.843 65.6814 67.618 65.2427C67.393 64.804 67.1572 64.4341 66.9107 64.1328C66.6641 63.8315 66.3848 63.5573 66.0727 63.31C65.7606 63.0628 65.3892 62.8457 64.9587 62.6587C64.5282 62.4718 63.992 62.2974 63.3501 62.1357L62.1689 61.8498C61.3502 61.6612 60.7305 61.5411 60.3096 61.4897C59.8888 61.4383 59.4321 61.454 58.9395 61.5367C58.4469 61.6195 57.9976 61.7599 57.5918 61.9579C57.1859 62.156 56.8541 62.3637 56.5965 62.581C56.3389 62.7983 56.0869 63.0324 55.8407 63.2835C55.5945 63.5345 55.3658 63.844 55.1548 64.2118C54.9437 64.5796 54.7163 65.1041 54.4724 65.7853L52.3786 73.5996C52.2533 74.0672 52.1606 74.5179 52.1006 74.9517C52.0406 75.3856 52.0111 75.8967 52.0119 76.4849C52.0128 77.0732 52.1124 77.5984 52.3107 78.0606C52.509 78.5228 52.7158 78.9054 52.9311 79.2086C53.1465 79.5117 53.4142 79.8007 53.7342 80.0757C54.0543 80.3506 54.3448 80.564 54.6058 80.7157C54.8668 80.8675 55.3043 81.0665 55.9184 81.3128ZM58.9603 77.6028L58.7886 77.5568C58.1875 77.3957 57.7482 77.1936 57.4708 76.9506C57.1933 76.7075 56.9775 76.3965 56.8233 76.0178C56.6692 75.639 56.6229 75.2201 56.6845 74.7611C56.7462 74.3021 56.8511 73.7959 56.9994 73.2425L58.3426 68.1722C58.553 67.3491 58.768 66.8136 58.9879 66.5657C59.2077 66.3178 59.3981 66.1413 59.5592 66.0362C59.7203 65.9311 59.9643 65.8507 60.2911 65.7951C60.6179 65.7395 60.8863 65.7399 61.0962 65.7961L61.7221 65.9792C62.1558 66.1158 62.517 66.2944 62.8057 66.5149C63.0943 66.7354 63.2932 66.9472 63.4024 67.1503C63.5116 67.3535 63.552 67.7273 63.5237 68.272C63.4953 68.8166 63.4185 69.3227 63.2933 69.7902L61.9894 74.6562C61.9485 74.8089 61.8181 75.1907 61.5982 75.8016C61.3782 76.4125 61.1771 76.829 60.9949 77.0512C60.8126 77.2733 60.5282 77.4477 60.1415 77.5741C59.7548 77.7006 59.3611 77.7102 58.9603 77.6028Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M54.5385 82.4164C55.1526 82.6627 55.6469 82.831 56.0216 82.9211C56.1552 82.9569 56.5204 83.0343 57.1175 83.1534C57.7145 83.2725 58.1781 83.3456 58.5083 83.3727C58.8385 83.3998 59.1865 83.3985 59.5524 83.3687C59.9184 83.3389 60.277 83.279 60.6283 83.1891C60.9797 83.0992 61.2779 82.9976 61.523 82.8843C61.7681 82.771 62.0426 82.5863 62.3464 82.3303C62.6502 82.0742 62.9556 81.6882 63.2626 81.1722C63.5696 80.6562 63.7901 80.2244 63.9241 79.8769C64.0582 79.5293 64.2223 78.9929 64.4166 78.2678L66.476 70.5823C66.5654 70.2483 66.6373 69.8943 66.6915 69.5203C66.7457 69.1462 66.7711 68.813 66.7676 68.5206C66.7641 68.2282 66.7313 67.9024 66.6691 67.5431C66.6068 67.1839 66.4632 66.7849 66.2381 66.3462C66.0131 65.9075 65.7773 65.5376 65.5308 65.2363C65.2843 64.9351 65.0049 64.6608 64.6928 64.4136C64.3807 64.1663 64.0094 63.9492 63.5788 63.7622C63.1483 63.5753 62.6121 63.4009 61.9703 63.2392L60.789 62.9534C59.9703 62.7647 59.3506 62.6446 58.9297 62.5932C58.5089 62.5418 58.0522 62.5575 57.5596 62.6403C57.067 62.723 56.6178 62.8634 56.2119 63.0615C55.806 63.2595 55.4743 63.4672 55.2166 63.6845C54.959 63.9018 54.7071 64.1359 54.4608 64.387C54.2146 64.638 53.986 64.9475 53.7749 65.3153C53.5639 65.6831 53.3364 66.2077 53.0925 66.8888L50.9987 74.7032C50.8734 75.1707 50.7808 75.6214 50.7207 76.0553C50.6607 76.4891 50.6312 77.0002 50.6321 77.5884C50.6329 78.1767 50.7325 78.7019 50.9308 79.1641C51.1291 79.6263 51.3359 80.0089 51.5513 80.3121C51.7666 80.6152 52.0343 80.9042 52.3543 81.1792C52.6744 81.4541 52.9649 81.6675 53.2259 81.8192C53.4869 81.971 53.9245 82.17 54.5385 82.4164ZM57.5804 78.7063L57.4087 78.6603C56.8076 78.4992 56.3683 78.2971 56.0909 78.0541C55.8134 77.811 55.5976 77.5001 55.4434 77.1213C55.2893 76.7425 55.243 76.3236 55.3046 75.8646C55.3663 75.4056 55.4712 74.8994 55.6195 74.346L56.9628 69.2757C57.1731 68.4526 57.3882 67.9171 57.608 67.6692C57.8278 67.4213 58.0182 67.2448 58.1794 67.1397C58.3405 67.0346 58.5844 66.9543 58.9112 66.8987C59.238 66.8431 59.5064 66.8434 59.7163 66.8996L60.3422 67.0827C60.776 67.2194 61.1372 67.3979 61.4258 67.6185C61.7144 67.839 61.9133 68.0508 62.0225 68.2539C62.1317 68.457 62.1721 68.8308 62.1438 69.3755C62.1155 69.9201 62.0387 70.4262 61.9134 70.8937L60.6095 75.7598C60.5686 75.9124 60.4382 76.2942 60.2183 76.9051C59.9983 77.516 59.7972 77.9325 59.615 78.1547C59.4328 78.3768 59.1483 78.5512 58.7616 78.6776C58.3749 78.8041 57.9812 78.8137 57.5804 78.7063Z"
      fill="#131313"
    />
    <path
      d="M54.5385 82.4164C55.1526 82.6627 55.6469 82.831 56.0216 82.9211C56.1552 82.9569 56.5204 83.0343 57.1175 83.1534C57.7145 83.2725 58.1781 83.3456 58.5083 83.3727C58.8385 83.3998 59.1865 83.3985 59.5524 83.3687C59.9184 83.3389 60.277 83.279 60.6283 83.1891C60.9797 83.0992 61.2779 82.9976 61.523 82.8843C61.7681 82.771 62.0426 82.5863 62.3464 82.3303C62.6502 82.0742 62.9556 81.6882 63.2626 81.1722C63.5696 80.6562 63.7901 80.2244 63.9241 79.8769C64.0582 79.5293 64.2223 78.9929 64.4166 78.2678L66.476 70.5823C66.5654 70.2483 66.6373 69.8943 66.6915 69.5203C66.7457 69.1462 66.7711 68.813 66.7676 68.5206C66.7641 68.2282 66.7313 67.9024 66.6691 67.5431C66.6068 67.1839 66.4632 66.7849 66.2381 66.3462C66.0131 65.9075 65.7773 65.5376 65.5308 65.2363C65.2843 64.9351 65.0049 64.6608 64.6928 64.4136C64.3807 64.1663 64.0094 63.9492 63.5788 63.7622C63.1483 63.5753 62.6121 63.4009 61.9703 63.2392L60.789 62.9534C59.9703 62.7647 59.3506 62.6446 58.9297 62.5932C58.5089 62.5418 58.0522 62.5575 57.5596 62.6403C57.067 62.723 56.6178 62.8634 56.2119 63.0615C55.806 63.2595 55.4743 63.4672 55.2166 63.6845C54.959 63.9018 54.7071 64.1359 54.4608 64.387C54.2146 64.638 53.986 64.9475 53.7749 65.3153C53.5639 65.6831 53.3364 66.2077 53.0925 66.8888L50.9987 74.7032C50.8734 75.1707 50.7808 75.6214 50.7207 76.0553C50.6607 76.4891 50.6312 77.0002 50.6321 77.5884C50.6329 78.1767 50.7325 78.7019 50.9308 79.1641C51.1291 79.6263 51.3359 80.0089 51.5513 80.3121C51.7666 80.6152 52.0343 80.9042 52.3543 81.1792C52.6744 81.4541 52.9649 81.6675 53.2259 81.8192C53.4869 81.971 53.9245 82.17 54.5385 82.4164ZM57.5804 78.7063L57.4087 78.6603C56.8076 78.4992 56.3683 78.2971 56.0909 78.0541C55.8134 77.811 55.5976 77.5001 55.4434 77.1213C55.2893 76.7425 55.243 76.3236 55.3046 75.8646C55.3663 75.4056 55.4712 74.8994 55.6195 74.346L56.9628 69.2757C57.1731 68.4526 57.3882 67.9171 57.608 67.6692C57.8278 67.4213 58.0182 67.2448 58.1794 67.1397C58.3405 67.0346 58.5844 66.9543 58.9112 66.8987C59.238 66.8431 59.5064 66.8434 59.7163 66.8996L60.3422 67.0827C60.776 67.2194 61.1372 67.3979 61.4258 67.6185C61.7144 67.839 61.9133 68.0508 62.0225 68.2539C62.1317 68.457 62.1721 68.8308 62.1438 69.3755C62.1155 69.9201 62.0387 70.4262 61.9134 70.8937L60.6095 75.7598C60.5686 75.9124 60.4382 76.2942 60.2183 76.9051C59.9983 77.516 59.7972 77.9325 59.615 78.1547C59.4328 78.3768 59.1483 78.5512 58.7616 78.6776C58.3749 78.8041 57.9812 78.8137 57.5804 78.7063Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M80.7272 80.7313L80.723 82.9409L85.954 82.8832L85.949 87.2327L79.9693 87.297L79.9691 85.4236L70.3506 85.4339V80.7442L80.7272 80.7313ZM89.1434 80.5993V85.0131L86.3903 85.0312V80.6174L89.1434 80.5993ZM82.7076 73.1643L83.0346 78.9192L73.9484 78.4945L82.7076 73.1643Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M85.9546 82.8818V87.0287L86.3871 85.392L86.3903 80.6177L85.9546 82.8818Z"
      fill="#AFB7C3"
    />
    <path
      d="M89.1443 80.5984L89.5915 78.3135L89.5958 83.3947L89.1431 85.026L89.1443 80.5984Z"
      fill="#AFB7C3"
    />
    <path
      d="M85.9546 82.8817L86.3903 80.6176L89.1443 80.5983L89.5915 78.2891L86.8375 78.2939L88.0186 72.157L82.1514 72.0859L70.8268 78.1368L70.3452 80.7299L80.4033 80.6595L79.9676 82.9542L85.9546 82.8817ZM80.8505 78.3044L75.7017 78.3134L81.4812 74.9831L80.8505 78.3044Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M28.4002 61.5457L30.9332 64.7265L38.2272 54.8739L23.5111 55.5214L25.7109 58.4765L36.2591 55.7751L26.7615 59.8791L25.0711 62.8755L28.4002 61.5457Z"
      fill="url(#paint10_linear_2242_16398)"
    />
    <path
      d="M113.036 32.4588C111.707 35.6295 110.075 38.4174 108.14 40.8224C94.2253 57.3682 75.813 44.4303 71.6001 43.5616C56.6502 40.6 52.9815 48.8387 52.4041 49.7489C50.4832 52.7453 50.6625 57.9896 52.9059 59.3077C56.7794 60.1836 57.7358 58.0593 58.2453 56.2649C57.9765 54.9969 57.6292 52.39 52.134 51.7331C47.028 52.0994 43.0292 54.1022 40.1371 57.7411"
      stroke="var(--xzx-brand-3)"
      stroke-width="0.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="4 4"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2242_16398"
        x1="33.3718"
        y1="25.1807"
        x2="8.53467"
        y2="25.1807"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2242_16398"
        x1="104.73"
        y1="31.4316"
        x2="86.9214"
        y2="31.4316"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2242_16398"
        x1="72.5344"
        y1="32.9048"
        x2="97.3716"
        y2="32.9048"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F7F9FF" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2242_16398"
        x1="84.0397"
        y1="5.50041"
        x2="66.2314"
        y2="5.50041"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2242_16398"
        x1="107.862"
        y1="70.155"
        x2="96.2759"
        y2="70.155"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2242_16398"
        x1="118.897"
        y1="75.6721"
        x2="107.311"
        y2="75.6721"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2242_16398"
        x1="21.5171"
        y1="73.7412"
        x2="5.24121"
        y2="73.7412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2242_16398"
        x1="27.3102"
        y1="83.9478"
        x2="72.5516"
        y2="105.465"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2242_16398"
        x1="70.6207"
        y1="81.1893"
        x2="101.408"
        y2="80.8991"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2242_16398"
        x1="51.3104"
        y1="77.6031"
        x2="100.426"
        y2="82.2705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2242_16398"
        x1="27.586"
        y1="61.0512"
        x2="38.2342"
        y2="60.7291"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
    </defs>
  </svg>
)

export const renderLoss = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="104"
    viewBox="0 0 120 104"
    fill="none"
  >
    <path
      d="M30.0086 20.8701H27.9916C27.9916 16.8327 24.7187 13.5598 20.6813 13.5598C16.644 13.5598 13.3709 16.8327 13.3709 20.8701H11.8977C10.0403 20.8701 8.53467 22.5067 8.53467 24.5254C8.53467 26.5441 10.0404 28.1805 11.8977 28.1805H30.0087C31.8663 28.1805 33.3718 26.544 33.3718 24.5254C33.3718 22.5066 31.8662 20.8701 30.0086 20.8701Z"
      fill="url(#paint0_linear_2242_16438)"
    />
    <path
      d="M81.6279 5.6036H80.1818C80.1818 2.70877 77.8351 0.362305 74.9403 0.362305C72.0453 0.362305 69.6987 2.70877 69.6987 5.6036H68.6423C67.3106 5.6036 66.231 6.77718 66.231 8.2245C66.231 9.67183 67.3106 10.8451 68.6423 10.8451H81.6279C82.9597 10.8451 84.0392 9.67183 84.0392 8.2245C84.0392 6.77718 82.9597 5.6036 81.6279 5.6036Z"
      fill="url(#paint1_linear_2242_16438)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.3448 71.9133C75.2771 71.9133 90.5248 73.2945 101.183 75.5006C111.607 75.57 120 78.6924 120 82.534C120 85.5786 114.728 88.1714 107.351 89.1508C105.591 89.6717 103.609 90.1627 101.432 90.619C101.489 90.9097 101.517 91.2034 101.517 91.4995C101.517 98.2031 86.9433 103.637 68.9655 103.637C52.7912 103.637 39.3721 99.2388 36.8425 93.4745C15.2605 91.8356 0 87.8019 0 83.0857C0 76.9154 26.1219 71.9133 58.3448 71.9133Z"
      fill="var(--xzx-brand-1)"
    />
    <path
      d="M107.672 67.932C107.695 68.0228 107.724 68.1194 107.759 68.2216L107.828 68.4942C107.851 68.585 107.862 68.6588 107.862 68.7156C107.862 69.0336 107.776 69.3147 107.603 69.5589C107.431 69.803 107.207 69.9819 106.931 70.0955C106.828 70.1068 106.718 70.1125 106.603 70.1125C106.512 70.1239 106.408 70.1295 106.293 70.1295H105.966L103.276 70.1636V73.0085C103.276 73.4287 103.284 73.8518 103.302 74.2776C103.319 74.7035 103.339 75.0868 103.362 75.4275C103.385 75.8364 103.414 76.2282 103.448 76.603H100.966L101.017 75.9386C101.029 75.6774 101.04 75.3225 101.052 74.8739C101.063 74.4253 101.069 73.8262 101.069 73.0767V70.4702C100.874 70.6406 100.655 70.7258 100.414 70.7258C100.218 70.7258 100.049 70.6804 99.9052 70.5895C99.7615 70.4986 99.6437 70.3737 99.5517 70.2147L97.6035 70.1125C97.2242 70.0217 96.9081 69.8314 96.6552 69.5418C96.4023 69.2522 96.2759 68.9087 96.2759 68.5112C96.2759 68.443 96.2816 68.3806 96.2931 68.3238C96.3046 68.267 96.3219 68.2102 96.3448 68.1534L96.7759 67.1654C96.7989 66.9155 96.8707 66.6827 96.9914 66.467C97.1121 66.2512 97.2644 66.0638 97.4483 65.9048L100.155 60.9475H100.172C100.391 60.55 100.649 60.2093 100.948 59.9254C101.247 59.6415 101.632 59.4995 102.103 59.4995C102.517 59.4995 102.888 59.6074 103.216 59.8232C103.543 60.039 103.787 60.3229 103.948 60.6749L106.121 64.8827C106.512 65.019 106.833 65.2574 107.086 65.5982C107.339 65.9389 107.466 66.3307 107.466 66.7736C107.466 66.9553 107.437 67.1484 107.379 67.3528L107.672 67.932Z"
      fill="url(#paint2_linear_2242_16438)"
    />
    <path
      d="M118.707 73.4493C118.73 73.5402 118.759 73.6367 118.793 73.7389L118.862 74.0115C118.885 74.1023 118.897 74.1762 118.897 74.2329C118.897 74.5509 118.811 74.832 118.638 75.0762C118.466 75.3204 118.242 75.4992 117.966 75.6128C117.862 75.6242 117.753 75.6298 117.638 75.6298C117.546 75.6412 117.443 75.6469 117.328 75.6469H117L114.311 75.6809V78.5258C114.311 78.946 114.319 79.3691 114.336 79.795C114.354 80.2209 114.374 80.6042 114.397 80.9449C114.42 81.3537 114.448 81.7455 114.483 82.1203H112L112.052 81.4559C112.063 81.1947 112.075 80.8398 112.086 80.3912C112.098 79.9426 112.104 79.3435 112.104 78.594V75.9876C111.908 76.1579 111.69 76.2431 111.448 76.2431C111.253 76.2431 111.084 76.1977 110.94 76.1068C110.796 76.016 110.678 75.891 110.586 75.7321L108.638 75.6298C108.259 75.539 107.943 75.3488 107.69 75.0592C107.437 74.7696 107.311 74.426 107.311 74.0285C107.311 73.9604 107.316 73.8979 107.328 73.8411C107.339 73.7844 107.357 73.7276 107.38 73.6708L107.811 72.6827C107.834 72.4329 107.905 72.2001 108.026 71.9843C108.147 71.7685 108.299 71.5811 108.483 71.4221L111.19 66.4648H111.207C111.425 66.0674 111.684 65.7267 111.983 65.4427C112.282 65.1588 112.667 65.0168 113.138 65.0168C113.552 65.0168 113.923 65.1247 114.25 65.3405C114.578 65.5563 114.822 65.8402 114.983 66.1923L117.155 70.4C117.546 70.5363 117.868 70.7748 118.121 71.1155C118.374 71.4562 118.5 71.848 118.5 72.2909C118.5 72.4726 118.471 72.6657 118.414 72.8701L118.707 73.4493Z"
      fill="url(#paint3_linear_2242_16438)"
    />
    <path
      d="M21.2507 71.4682C21.2829 71.5971 21.3233 71.7342 21.3718 71.8792L21.4686 72.2661C21.5009 72.3951 21.5171 72.4998 21.5171 72.5804C21.5171 73.0318 21.396 73.4307 21.1538 73.7773C20.9116 74.1239 20.5967 74.3777 20.2092 74.5389C20.0639 74.5551 19.9105 74.5631 19.749 74.5631C19.6198 74.5792 19.4745 74.5873 19.3131 74.5873H18.8529L15.0745 74.6357V78.6736C15.0745 79.27 15.0867 79.8704 15.1109 80.4749C15.1351 81.0794 15.1634 81.6234 15.1956 82.107C15.2279 82.6873 15.2683 83.2434 15.3167 83.7754H11.8291L11.9017 82.8324C11.9179 82.4616 11.934 81.9579 11.9502 81.3212C11.9663 80.6845 11.9744 79.8342 11.9744 78.7703V75.0709C11.6999 75.3127 11.3931 75.4336 11.054 75.4336C10.7795 75.4336 10.5414 75.3691 10.3395 75.2401C10.1377 75.1112 9.97219 74.9339 9.84302 74.7082L7.10615 74.5631C6.57331 74.4342 6.12928 74.1642 5.77405 73.7531C5.41882 73.3421 5.24121 72.8545 5.24121 72.2903C5.24121 72.1936 5.24928 72.1049 5.26543 72.0243C5.28158 71.9437 5.3058 71.8631 5.33809 71.7825L5.94359 70.3801C5.97589 70.0255 6.0768 69.6951 6.24634 69.3888C6.41588 69.0825 6.62983 68.8165 6.88817 68.5909L10.6907 61.5547H10.7149C11.0217 60.9906 11.385 60.507 11.8048 60.104C12.2247 59.701 12.7656 59.4995 13.4276 59.4995C14.0089 59.4995 14.5296 59.6526 14.9898 59.9589C15.45 60.2652 15.7931 60.6682 16.0191 61.1679L19.0708 67.1401C19.6198 67.3336 20.0719 67.6721 20.4272 68.1556C20.7824 68.6392 20.96 69.1954 20.96 69.824C20.96 70.0819 20.9196 70.3559 20.8389 70.6461L21.2507 71.4682Z"
      fill="url(#paint4_linear_2242_16438)"
    />
    <path
      d="M63.0338 88.4921C68.2901 88.4921 72.5511 87.3806 72.5511 86.0094C72.5511 84.6382 68.2901 83.5266 63.0338 83.5266C57.7776 83.5266 53.5166 84.6382 53.5166 86.0094C53.5166 87.3806 57.7776 88.4921 63.0338 88.4921Z"
      fill="#D1D6E2"
    />
    <path
      d="M63.7234 21.1547C63.7234 20.2406 62.9824 19.4995 62.0683 19.4995C61.1541 19.4995 60.4131 20.2406 60.4131 21.1547V81.2926C60.4131 82.2067 61.1541 82.9478 62.0683 82.9478C62.9824 82.9478 63.7234 82.2067 63.7234 81.2926V21.1547Z"
      fill="var(--xzx-brand-4)"
    />
    <path
      d="M62.2522 88.4922C69.1081 88.4922 74.666 86.8866 74.666 84.906C74.666 82.9254 69.1081 81.3198 62.2522 81.3198C55.3962 81.3198 49.8384 82.9254 49.8384 84.906C49.8384 86.8866 55.3962 88.4922 62.2522 88.4922Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M62.1713 81.0169C63.1053 74.1517 60.7059 70.4532 54.9731 69.9216C62.7326 69.2082 67.869 73.751 67.9521 81.0169C66.3434 81.0708 64.4165 81.0708 62.1713 81.0169Z"
      fill="url(#paint5_linear_2242_16438)"
    />
    <path
      d="M65.9394 81.0573C67.4542 74.1294 65.5911 69.0125 60.3501 65.7065C67.0422 67.7369 71.8499 70.7882 73.4127 81.0573C71.3704 81.2028 68.8793 81.2028 65.9394 81.0573Z"
      fill="url(#paint6_linear_2242_16438)"
    />
    <path
      d="M74.6001 81.1663C73.9302 74.5818 76.387 70.809 81.9706 69.8481C76.7916 69.7219 71.0144 69.3876 66.8813 81.1663C70.3839 81.0582 72.9568 81.0582 74.6001 81.1663Z"
      fill="url(#paint7_linear_2242_16438)"
    />
    <path
      d="M58.6373 85.6055C64.0459 85.6055 68.1375 85.733 68.1375 80.8162C68.1375 75.8993 63.753 71.9133 58.3444 71.9133C52.9358 71.9133 48.5513 75.8993 48.5513 80.8162C48.5513 85.733 53.2287 85.6055 58.6373 85.6055Z"
      fill="url(#paint8_linear_2242_16438)"
    />
    <path
      d="M69.4527 85.7061C72.8207 85.7061 75.3687 85.7855 75.3687 82.7237C75.3687 79.6618 72.6383 77.1797 69.2703 77.1797C65.9022 77.1797 63.1719 79.6618 63.1719 82.7237C63.1719 85.7855 66.0846 85.7061 69.4527 85.7061Z"
      fill="url(#paint9_linear_2242_16438)"
    />
    <path
      d="M40.3241 24.4651L83.29 26.7168L88.0025 32.7083L82.6896 38.1744L39.7236 35.9227L45.0366 30.4566L40.3241 24.4651Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.8037 29.6955C56.5644 29.7354 57.1488 30.3844 57.1089 31.1451C57.0691 31.9058 56.4201 32.4902 55.6593 32.4503C54.8986 32.4105 54.3142 31.7615 54.3541 31.0007C54.394 30.24 55.043 29.6556 55.8037 29.6955ZM64.072 29.9842C64.8327 30.0241 65.4171 30.6731 65.3772 31.4339C65.3374 32.1946 64.6884 32.779 63.9276 32.7391C63.1669 32.6992 62.5825 32.0502 62.6224 31.2895C62.6623 30.5288 63.3113 29.9444 64.072 29.9842ZM72.3403 30.273C73.101 30.3129 73.6854 30.9619 73.6455 31.7226C73.6057 32.4833 72.9567 33.0677 72.1959 33.0278C71.4352 32.988 70.8508 32.339 70.8907 31.5782C70.9306 30.8175 71.5796 30.2331 72.3403 30.273Z"
      fill="white"
    />
    <path
      d="M80.6719 41.5479H48.5638L44.8178 45.8289L48.5638 50.11H80.6719L76.9259 45.8289L80.6719 41.5479Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M42.5405 54.0618L74.5265 51.2634L78.6313 55.2017L75.2727 59.7929L43.2868 62.5913L46.6453 58.0001L42.5405 54.0618Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M110.505 25.396C104.401 27.5861 99.2828 27.7298 95.1501 25.8272C91.8582 24.225 91.666 19.5662 94.3056 18.9568C96.9451 18.3474 99.0544 20.1799 99.8442 23.6012C100.634 27.0225 99.8288 31.4009 97.7186 33.7403"
      stroke="url(#paint10_linear_2242_16438)"
      stroke-width="0.5"
      stroke-linecap="round"
    />
    <path
      d="M94.047 36.9832C92.3052 35.6087 90.6778 36.0144 89.1649 38.2004C88.3797 39.4164 88.0868 41.121 86.5683 41.4996C91.7442 41.9725 94.2371 40.467 94.047 36.9832Z"
      fill="url(#paint11_linear_2242_16438)"
    />
    <path
      d="M95.7822 35.1941C95.531 36.2669 93.7334 37.7253 90.3891 39.5694"
      stroke="url(#paint12_linear_2242_16438)"
      stroke-width="0.5"
      stroke-linecap="round"
    />
    <path
      d="M36.49 73.7375C35.1945 71.9361 33.5184 71.8776 31.4615 73.5619C30.3715 74.5143 29.6202 76.0721 28.0562 76.0175C32.9012 77.8987 35.7125 77.1387 36.49 73.7375Z"
      fill="url(#paint13_linear_2242_16438)"
    />
    <path
      d="M38.6517 72.4957C38.1146 73.4577 35.9846 74.3642 32.2616 75.215"
      stroke="url(#paint14_linear_2242_16438)"
      stroke-width="0.5"
      stroke-linecap="round"
    />
    <path
      d="M40.5428 65.6034C36.8286 68.4209 33.5977 70.1468 30.85 70.7812"
      stroke="url(#paint15_linear_2242_16438)"
      stroke-width="0.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2242_16438"
        x1="33.3718"
        y1="20.8702"
        x2="8.53467"
        y2="20.8702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2242_16438"
        x1="84.0392"
        y1="5.60368"
        x2="66.231"
        y2="5.60368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2242_16438"
        x1="107.862"
        y1="68.0512"
        x2="96.2759"
        y2="68.0512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2242_16438"
        x1="118.897"
        y1="73.5686"
        x2="107.311"
        y2="73.5686"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2242_16438"
        x1="21.5171"
        y1="71.6374"
        x2="5.24121"
        y2="71.6374"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2242_16438"
        x1="61.4626"
        y1="80.657"
        x2="65.4993"
        y2="71.1644"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2242_16438"
        x1="66.8814"
        y1="80.6143"
        x2="73.6067"
        y2="69.0735"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2242_16438"
        x1="74.426"
        y1="80.7609"
        x2="78.1233"
        y2="70.7791"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2242_16438"
        x1="52.9651"
        y1="73.5685"
        x2="58.8565"
        y2="86.9068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2242_16438"
        x1="65.3788"
        y1="78.8098"
        x2="70.6635"
        y2="86.6979"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2242_16438"
        x1="104.828"
        y1="18.672"
        x2="93.7939"
        y2="30.8099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2242_16438"
        x1="93.798"
        y1="38.4676"
        x2="89.2652"
        y2="38.1899"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2242_16438"
        x1="95.8309"
        y1="35.025"
        x2="92.5778"
        y2="40.6999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2242_16438"
        x1="35.8415"
        y1="75.0958"
        x2="31.5608"
        y2="73.5794"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2242_16438"
        x1="38.7452"
        y1="72.3466"
        x2="34.0539"
        y2="76.9049"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2242_16438"
        x1="40.6544"
        y1="65.4255"
        x2="38.5246"
        y2="72.8503"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-3)" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export const renderNoSignal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="104"
    viewBox="0 0 120 104"
    fill="none"
  >
    <path
      d="M102.725 7.81036C102.725 9.44829 101.191 10.7586 99.2539 10.7586H88.5173C86.5799 10.6276 84.9653 9.38277 84.9653 7.67932C84.9653 6.56553 85.6919 5.58277 86.7413 5.05863C86.6606 4.86208 86.5799 4.66553 86.5799 4.46898C86.5799 3.35519 87.6293 2.37243 89.0017 2.37243C89.5667 2.37243 90.0511 2.56898 90.4547 2.83105C91.4235 1.32415 93.1994 0.275879 95.2983 0.275879C98.2045 0.275879 100.546 2.30691 100.546 4.79656V5.05863C101.837 5.51725 102.725 6.56553 102.725 7.81036Z"
      fill="url(#paint0_linear_2242_16470)"
    />
    <path
      d="M29.5265 66.0375C29.5588 66.1665 29.5992 66.3035 29.6476 66.4486L29.7445 66.8354C29.7768 66.9644 29.7929 67.0692 29.7929 67.1498C29.7929 67.6011 29.6718 68.0001 29.4296 68.3466C29.1874 68.6932 28.8726 68.9471 28.4851 69.1083C28.3397 69.1244 28.1863 69.1324 28.0249 69.1324C27.8957 69.1486 27.7504 69.1566 27.5889 69.1566H27.1287L23.3504 69.205V73.2429C23.3504 73.8393 23.3625 74.4398 23.3867 75.0442C23.411 75.6487 23.4392 76.1927 23.4715 76.6763C23.5038 77.2566 23.5442 77.8127 23.5926 78.3447H20.1049L20.1776 77.4017C20.1937 77.031 20.2099 76.5272 20.226 75.8905C20.2422 75.2538 20.2503 74.4035 20.2503 73.3396V69.6402C19.9758 69.882 19.669 70.0029 19.3299 70.0029C19.0554 70.0029 18.8172 69.9384 18.6154 69.8095C18.4136 69.6805 18.2481 69.5032 18.1189 69.2775L15.382 69.1324C14.8492 69.0035 14.4052 68.7335 14.0499 68.3224C13.6947 67.9114 13.5171 67.4238 13.5171 66.8596C13.5171 66.7629 13.5252 66.6742 13.5413 66.5936C13.5575 66.513 13.5817 66.4324 13.614 66.3518L14.2195 64.9495C14.2518 64.5948 14.3527 64.2644 14.5222 63.9581C14.6918 63.6518 14.9057 63.3859 15.1641 63.1602L18.9666 56.1241H18.9908C19.2976 55.5599 19.6609 55.0763 20.0807 54.6733C20.5005 54.2703 21.0414 54.0688 21.7035 54.0688C22.2847 54.0688 22.8055 54.222 23.2656 54.5283C23.7258 54.8345 24.0689 55.2375 24.295 55.7372L27.3467 61.7095C27.8957 61.9029 28.3478 62.2414 28.703 62.725C29.0583 63.2086 29.2359 63.7647 29.2359 64.3933C29.2359 64.6512 29.1955 64.9253 29.1148 65.2154L29.5265 66.0375Z"
      fill="url(#paint1_linear_2242_16470)"
    />
    <path
      d="M115.044 66.0375C115.076 66.1665 115.116 66.3035 115.165 66.4486L115.262 66.8354C115.294 66.9644 115.31 67.0692 115.31 67.1498C115.31 67.6011 115.189 68.0001 114.947 68.3466C114.705 68.6932 114.39 68.9471 114.002 69.1083C113.857 69.1244 113.703 69.1324 113.542 69.1324C113.413 69.1486 113.267 69.1566 113.106 69.1566H112.646L108.868 69.205V73.2429C108.868 73.8393 108.88 74.4398 108.904 75.0442C108.928 75.6487 108.956 76.1927 108.989 76.6763C109.021 77.2566 109.061 77.8127 109.11 78.3447H105.622L105.695 77.4017C105.711 77.031 105.727 76.5272 105.743 75.8905C105.759 75.2538 105.767 74.4035 105.767 73.3396V69.6402C105.493 69.882 105.186 70.0029 104.847 70.0029C104.572 70.0029 104.334 69.9384 104.132 69.8095C103.931 69.6805 103.765 69.5032 103.636 69.2775L100.899 69.1324C100.366 69.0035 99.9222 68.7335 99.567 68.3224C99.2118 67.9114 99.0342 67.4238 99.0342 66.8596C99.0342 66.7629 99.0423 66.6742 99.0584 66.5936C99.0745 66.513 99.0988 66.4324 99.1311 66.3518L99.7366 64.9495C99.7689 64.5948 99.8698 64.2644 100.039 63.9581C100.209 63.6518 100.423 63.3859 100.681 63.1602L104.484 56.1241H104.508C104.815 55.5599 105.178 55.0763 105.598 54.6733C106.018 54.2703 106.559 54.0688 107.221 54.0688C107.802 54.0688 108.323 54.222 108.783 54.5283C109.243 54.8345 109.586 55.2375 109.812 55.7372L112.864 61.7095C113.413 61.9029 113.865 62.2414 114.22 62.725C114.575 63.2086 114.753 63.7647 114.753 64.3933C114.753 64.6512 114.713 64.9253 114.632 65.2154L115.044 66.0375Z"
      fill="url(#paint2_linear_2242_16470)"
    />
    <path
      d="M104.895 68.6948C104.921 68.7959 104.952 68.9034 104.99 69.0171L105.065 69.3205C105.091 69.4216 105.103 69.5037 105.103 69.5669C105.103 69.9208 105.009 70.2336 104.82 70.5054C104.631 70.7771 104.386 70.9762 104.084 71.1026C103.97 71.1152 103.851 71.1215 103.725 71.1215C103.624 71.1342 103.511 71.1405 103.385 71.1405H103.026L100.08 71.1784V74.3445C100.08 74.8121 100.09 75.283 100.109 75.7569C100.127 76.2309 100.149 76.6574 100.175 77.0366C100.2 77.4916 100.231 77.9277 100.269 78.3448H97.5499L97.6065 77.6054C97.6191 77.3147 97.6317 76.9197 97.6443 76.4205C97.6569 75.9212 97.6632 75.2545 97.6632 74.4203V71.5197C97.4491 71.7092 97.21 71.804 96.9456 71.804C96.7316 71.804 96.5459 71.7535 96.3885 71.6524C96.2312 71.5513 96.1021 71.4122 96.0014 71.2353L93.8676 71.1215C93.4522 71.0204 93.106 70.8087 92.829 70.4864C92.5521 70.1641 92.4136 69.7818 92.4136 69.3394C92.4136 69.2636 92.4199 69.1941 92.4325 69.1309C92.445 69.0677 92.4639 69.0045 92.4891 68.9413L92.9612 67.8417C92.9864 67.5636 93.065 67.3045 93.1972 67.0644C93.3294 66.8242 93.4962 66.6157 93.6976 66.4387L96.6623 60.9218H96.6812C96.9204 60.4794 97.2037 60.1002 97.531 59.7843C97.8583 59.4683 98.28 59.3103 98.7962 59.3103C99.2494 59.3103 99.6554 59.4304 100.014 59.6705C100.373 59.9107 100.64 60.2266 100.817 60.6184L103.196 65.3012C103.624 65.4529 103.977 65.7183 104.253 66.0975C104.53 66.4767 104.669 66.9127 104.669 67.4056C104.669 67.6079 104.637 67.8227 104.574 68.0502L104.895 68.6948Z"
      fill="url(#paint3_linear_2242_16470)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.3448 72C75.2771 72 90.5247 73.3812 101.183 75.5873C111.607 75.6567 120 78.779 120 82.6207C120 85.6653 114.728 88.2581 107.351 89.2374C105.591 89.7583 103.609 90.2493 101.432 90.7056C101.489 90.9963 101.517 91.29 101.517 91.5862C101.517 98.2898 86.9433 103.724 68.9655 103.724C52.7911 103.724 39.372 99.3254 36.8425 93.5611C15.2605 91.9223 0 87.8886 0 83.1724C0 77.0021 26.1218 72 58.3448 72Z"
      fill="var(--xzx-brand-1)"
    />
    <path
      d="M38.8964 10.1897C38.8964 12.3448 36.7045 14.069 33.9359 14.069H18.5929C15.8243 13.8966 13.5171 12.2586 13.5171 10.0173C13.5171 8.55173 14.5553 7.25863 16.055 6.56898C15.9397 6.31036 15.8243 6.05174 15.8243 5.79312C15.8243 4.3276 17.324 3.0345 19.2851 3.0345C20.0926 3.0345 20.7848 3.29312 21.3616 3.63794C22.7459 1.65519 25.2838 0.275879 28.2832 0.275879C32.4362 0.275879 35.7816 2.94829 35.7816 6.22415V6.56898C37.6274 7.17242 38.8964 8.55173 38.8964 10.1897Z"
      fill="url(#paint4_linear_2242_16470)"
    />
    <mask
      id="mask0_2242_16470"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="72"
      width="120"
      height="32"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.3448 72C75.2771 72 90.5247 73.3812 101.183 75.5873C111.607 75.6567 120 78.779 120 82.6207C120 85.6653 114.728 88.2581 107.351 89.2374C105.591 89.7583 103.609 90.2493 101.432 90.7056C101.489 90.9963 101.517 91.29 101.517 91.5862C101.517 98.2898 86.9433 103.724 68.9655 103.724C52.7911 103.724 39.372 99.3254 36.8425 93.5611C15.2605 91.9223 0 87.8886 0 83.1724C0 77.0021 26.1218 72 58.3448 72Z"
        fill="var(--xzx-brand-1)"
      />
    </mask>
    <g mask="url(#mask0_2242_16470)">
      <path
        d="M119.53 98.36L87.6363 107.088L63.4023 85.8035L77.34 83.6689L119.53 98.36Z"
        fill="url(#paint5_linear_2242_16470)"
      />
    </g>
    <path
      d="M68.9271 78.9224C73.3541 78.9224 77.0055 79.7885 77.5272 80.9066L77.5911 80.9066V84.1713L77.5904 84.1712L77.5911 84.1961C77.5911 85.4319 73.7893 86.436 69.0704 86.4559L68.9271 86.4562C64.1422 86.4562 60.2632 85.4443 60.2632 84.1961C60.2632 84.1878 60.2634 84.1795 60.2637 84.1712L60.2632 84.1713V80.9066L60.3271 80.9066C60.8488 79.7885 64.5002 78.9224 68.9271 78.9224Z"
      fill="url(#paint6_linear_2242_16470)"
    />
    <path
      d="M69.3555 80.3717L70.5479 81.0583L72.369 80.3717V63.4792H69.3555V80.3717Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M70.4329 63.4136H65.9126V80.9926H70.4329V63.4136Z"
      fill="#CCD8FF"
    />
    <path
      d="M74.8103 31.9864C83.8757 41.0521 83.8757 55.7497 74.8103 64.8154C65.745 73.8811 51.048 73.8811 41.9827 64.8154C41.4845 64.3172 41.0149 63.8012 40.5703 63.2726C40.3167 62.9691 40.0721 62.6601 39.8346 62.3477C37.4116 58.1335 41.7648 48.6161 50.1874 40.1932C58.6099 31.7703 68.1269 27.4169 72.3409 29.84C72.6534 30.0757 72.9605 30.3204 73.2658 30.5757C73.7979 31.0186 74.3139 31.4882 74.8103 31.9864Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M72.726 30.6961C72.7434 30.7408 72.7599 30.7831 72.7751 30.8315C74.4938 35.7148 68.4406 46.513 59.1448 55.0807C49.8491 63.6483 40.8004 66.775 38.8052 62.1465C38.7845 62.1032 38.768 62.0609 38.7505 62.0163C38.6239 61.6919 38.5339 61.3418 38.4763 60.965C37.7011 55.7392 43.5795 45.6983 52.3303 37.6314C61.0811 29.5645 69.6136 26.3208 72.2495 29.8312C72.4407 30.0849 72.5989 30.3738 72.726 30.6961Z"
      fill="var(--xzx-brand-5)"
    />
    <path
      d="M65.0384 48.8547L61.2657 53.0998L49.473 41.0919L51.0154 39.4842L65.0384 48.8547Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M48.8669 41.4215C50.458 41.3103 51.6576 39.9302 51.5464 38.3391C51.4351 36.748 50.0551 35.5484 48.464 35.6596C46.8729 35.7709 45.6732 37.1509 45.7845 38.742C45.8957 40.3331 47.2758 41.5328 48.8669 41.4215Z"
      fill="var(--xzx-brand-3)"
    />
    <path
      d="M42.8923 36.5065C42.5764 36.5061 42.2733 36.3802 42.0496 36.1566C41.826 35.9329 41.7001 35.6298 41.6997 35.314L41.6981 34.1235L40.5076 34.1218C39.8499 34.1209 39.316 33.587 39.3151 32.9293C39.3142 32.2716 39.8466 31.7392 40.5043 31.7401L41.6952 31.7421L41.6931 30.5513C41.6921 29.8934 42.2245 29.3608 42.8823 29.3616C43.5401 29.3624 44.0743 29.8963 44.0753 30.5542L44.0774 31.7459L45.2682 31.7471C45.9261 31.7482 46.46 32.2823 46.4608 32.9401C46.4616 33.5979 45.929 34.1303 45.2711 34.1293L44.0798 34.1276L44.0823 35.3173C44.0828 35.6331 43.9578 35.9359 43.7348 36.1589C43.5117 36.382 43.209 36.507 42.8931 36.5065H42.8923ZM35.6831 35.671C34.8744 35.8738 34.0524 35.3826 33.8466 34.5735C33.3952 31.9008 34.0784 29.1639 35.7317 27.0221C37.0256 25.4163 39.5693 23.5377 44.3512 23.7031C45.1734 23.7478 45.8104 24.4422 45.784 25.265C45.7577 26.0878 45.0776 26.7364 44.2543 26.7237C41.4161 26.6255 39.3418 27.3652 38.0875 28.9214C37.0343 30.3284 36.5646 32.0885 36.7759 33.8363C36.8746 34.2249 36.8149 34.6364 36.6101 34.9803C36.4052 35.3241 36.0719 35.5721 35.6835 35.6697L35.6831 35.671ZM43.8757 21.4158C39.6237 21.5097 36.4051 22.7234 34.3082 25.0218C31.2328 28.3957 31.4683 33.1166 31.5048 33.6425C31.5492 34.1846 31.2989 34.708 30.8493 35.0129C30.3998 35.3177 29.8204 35.357 29.3323 35.1156C28.8442 34.8743 28.5228 34.3896 28.4907 33.8466C28.4147 32.771 28.2318 27.1922 32.0713 22.9817C34.7437 20.0506 38.6922 18.5048 43.8007 18.3941C44.3405 18.3824 44.8463 18.6595 45.1276 19.1211C45.4089 19.5827 45.4231 20.1586 45.1646 20.6319C44.9062 21.1053 44.4146 21.4041 43.8748 21.4158L43.8757 21.4158Z"
      fill="url(#paint7_linear_2242_16470)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2242_16470"
        x1="102.725"
        y1="5.51725"
        x2="84.9653"
        y2="5.51725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2242_16470"
        x1="29.7929"
        y1="66.2068"
        x2="13.5171"
        y2="66.2068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2242_16470"
        x1="115.31"
        y1="66.2068"
        x2="99.0342"
        y2="66.2068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2242_16470"
        x1="105.103"
        y1="68.8275"
        x2="92.4136"
        y2="68.8275"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2242_16470"
        x1="38.8964"
        y1="7.17242"
        x2="13.5171"
        y2="7.17242"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2242_16470"
        x1="63.5279"
        y1="80.6554"
        x2="92.4136"
        y2="99.0344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2242_16470"
        x1="77.5911"
        y1="82.8552"
        x2="60.2632"
        y2="82.8552"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-5)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2242_16470"
        x1="44.5461"
        y1="34.4608"
        x2="37.8572"
        y2="19.4689"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
    </defs>
  </svg>
)

export const renderNoPermission = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="108"
    viewBox="0 0 120 108"
    fill="none"
  >
    <path
      d="M29.5265 69.4169C29.5588 69.5459 29.5992 69.6829 29.6476 69.828L29.7445 70.2148C29.7768 70.3438 29.793 70.4486 29.793 70.5292C29.793 70.9805 29.6719 71.3795 29.4297 71.726C29.1875 72.0726 28.8726 72.3265 28.4851 72.4877C28.3398 72.5038 28.1864 72.5119 28.0249 72.5119C27.8957 72.528 27.7504 72.536 27.5889 72.536H27.1287L23.3504 72.5844V76.6223C23.3504 77.2187 23.3625 77.8192 23.3868 78.4237C23.411 79.0281 23.4392 79.5722 23.4715 80.0557C23.5038 80.636 23.5442 81.1922 23.5926 81.7241H20.1049L20.1776 80.7811C20.1937 80.4104 20.2099 79.9066 20.226 79.2699C20.2422 78.6332 20.2503 77.7829 20.2503 76.719V73.0196C19.9758 73.2614 19.669 73.3823 19.3299 73.3823C19.0554 73.3823 18.8172 73.3178 18.6154 73.1889C18.4136 73.0599 18.2481 72.8826 18.1189 72.6569L15.382 72.5119C14.8492 72.3829 14.4052 72.1129 14.0499 71.7018C13.6947 71.2908 13.5171 70.8032 13.5171 70.239C13.5171 70.1423 13.5252 70.0536 13.5413 69.973C13.5575 69.8924 13.5817 69.8118 13.614 69.7312L14.2195 68.3289C14.2518 67.9742 14.3527 67.6438 14.5222 67.3375C14.6918 67.0312 14.9057 66.7653 15.1641 66.5396L18.9666 59.5035H18.9908C19.2976 58.9393 19.6609 58.4557 20.0807 58.0527C20.5005 57.6497 21.0414 57.4482 21.7035 57.4482C22.2847 57.4482 22.8055 57.6014 23.2657 57.9076C23.7258 58.2139 24.069 58.6169 24.295 59.1166L27.3467 65.0889C27.8957 65.2823 28.3478 65.6208 28.7031 66.1044C29.0583 66.588 29.2359 67.1441 29.2359 67.7727C29.2359 68.0306 29.1955 68.3047 29.1148 68.5948L29.5265 69.4169Z"
      fill="url(#paint0_linear_2242_16246)"
    />
    <path
      d="M115.044 69.4169C115.076 69.5459 115.116 69.6829 115.165 69.828L115.262 70.2148C115.294 70.3438 115.31 70.4486 115.31 70.5292C115.31 70.9805 115.189 71.3795 114.947 71.726C114.705 72.0726 114.39 72.3265 114.002 72.4877C113.857 72.5038 113.703 72.5119 113.542 72.5119C113.413 72.528 113.267 72.536 113.106 72.536H112.646L108.868 72.5844V76.6223C108.868 77.2187 108.88 77.8192 108.904 78.4237C108.928 79.0281 108.956 79.5722 108.989 80.0557C109.021 80.636 109.061 81.1922 109.11 81.7241H105.622L105.695 80.7811C105.711 80.4104 105.727 79.9066 105.743 79.2699C105.759 78.6332 105.767 77.7829 105.767 76.719V73.0196C105.493 73.2614 105.186 73.3823 104.847 73.3823C104.572 73.3823 104.334 73.3178 104.132 73.1889C103.931 73.0599 103.765 72.8826 103.636 72.6569L100.899 72.5119C100.366 72.3829 99.9222 72.1129 99.567 71.7018C99.2118 71.2908 99.0342 70.8032 99.0342 70.239C99.0342 70.1423 99.0423 70.0536 99.0584 69.973C99.0745 69.8924 99.0988 69.8118 99.1311 69.7312L99.7366 68.3289C99.7689 67.9742 99.8698 67.6438 100.039 67.3375C100.209 67.0312 100.423 66.7653 100.681 66.5396L104.484 59.5035H104.508C104.815 58.9393 105.178 58.4557 105.598 58.0527C106.018 57.6497 106.559 57.4482 107.221 57.4482C107.802 57.4482 108.323 57.6014 108.783 57.9076C109.243 58.2139 109.586 58.6169 109.812 59.1166L112.864 65.0889C113.413 65.2823 113.865 65.6208 114.22 66.1044C114.575 66.588 114.753 67.1441 114.753 67.7727C114.753 68.0306 114.713 68.3047 114.632 68.5948L115.044 69.4169Z"
      fill="url(#paint1_linear_2242_16246)"
    />
    <path
      d="M104.896 72.074C104.921 72.1751 104.952 72.2825 104.99 72.3963L105.065 72.6996C105.091 72.8007 105.103 72.8829 105.103 72.9461C105.103 73.3 105.009 73.6128 104.82 73.8845C104.631 74.1563 104.386 74.3553 104.084 74.4817C103.97 74.4944 103.851 74.5007 103.725 74.5007C103.624 74.5133 103.511 74.5196 103.385 74.5196H103.026L100.08 74.5576V77.7237C100.08 78.1913 100.09 78.6621 100.109 79.1361C100.127 79.61 100.149 80.0366 100.175 80.4158C100.2 80.8708 100.231 81.3068 100.269 81.7239H97.5499L97.6065 80.9845C97.6191 80.6938 97.6317 80.2989 97.6443 79.7996C97.6569 79.3004 97.6632 78.6337 97.6632 77.7995V74.8988C97.4491 75.0884 97.21 75.1832 96.9456 75.1832C96.7316 75.1832 96.5459 75.1326 96.3885 75.0315C96.2312 74.9304 96.1021 74.7914 96.0014 74.6144L93.8676 74.5007C93.4522 74.3996 93.106 74.1879 92.829 73.8656C92.5521 73.5433 92.4136 73.1609 92.4136 72.7186C92.4136 72.6427 92.4199 72.5732 92.4325 72.51C92.445 72.4468 92.4639 72.3836 92.4891 72.3204L92.9612 71.2208C92.9864 70.9428 93.065 70.6837 93.1972 70.4435C93.3294 70.2034 93.4962 69.9949 93.6976 69.8179L96.6623 64.3009H96.6812C96.9204 63.8586 97.2037 63.4794 97.531 63.1634C97.8583 62.8474 98.28 62.6895 98.7962 62.6895C99.2494 62.6895 99.6554 62.8095 100.014 63.0497C100.373 63.2898 100.64 63.6058 100.817 63.9976L103.196 68.6804C103.624 68.8321 103.977 69.0975 104.253 69.4766C104.53 69.8558 104.669 70.2919 104.669 70.7848C104.669 70.987 104.637 71.2019 104.574 71.4294L104.896 72.074Z"
      fill="url(#paint2_linear_2242_16246)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.3448 75.3794C75.2771 75.3794 90.5248 76.7606 101.183 78.9667C111.607 79.0361 120 82.1584 120 86.0001C120 89.0447 114.728 91.6375 107.351 92.6168C105.591 93.1377 103.609 93.6287 101.432 94.085C101.489 94.3757 101.517 94.6694 101.517 94.9656C101.517 101.669 86.9433 107.104 68.9655 107.104C52.7912 107.104 39.3721 102.705 36.8425 96.9405C15.2605 95.3017 0 91.268 0 86.5518C0 80.3815 26.1219 75.3794 58.3448 75.3794Z"
      fill="var(--xzx-brand-1)"
    />
    <path
      d="M78.0692 89.7512C84.011 89.7512 88.8278 88.6396 88.8278 87.2684C88.8278 85.8972 84.011 84.7856 78.0692 84.7856C72.1273 84.7856 67.3105 85.8972 67.3105 87.2684C67.3105 88.6396 72.1273 89.7512 78.0692 89.7512Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.6077 85.1245C53.6077 85.1245 51.8964 84.396 48.4736 82.9389H53.6077L46.5264 77.2007L57.1773 81.1626L62.3421 79.0171L62.957 82.9389L73.5234 78.3921L64.9741 85.8213H73.5234L67.4998 87.1739L71.949 89.8932L66.222 88.068L77.9712 96.3999C67.9617 92.148 62.957 90.1831 62.957 90.5052C62.957 90.8274 63.6294 92.1425 64.9741 94.4505L60.0981 91.7231L59.2034 94.4505L58.1161 92.7621C52.4719 95.6916 49.6499 96.9042 49.6499 96.3999C49.6499 95.8956 50.9691 94.3367 53.6077 91.7231L35.7801 93.6943L52.3882 88.5975H44.8469L51.2249 86.8559L35.1636 85.1245C47.4597 85.1245 53.6077 85.1245 53.6077 85.1245Z"
      fill="var(--xzx-brand-2)"
    />
    <path
      d="M102.725 8.43097C102.725 10.0689 101.191 11.3792 99.2539 11.3792H88.5173C86.5799 11.2482 84.9653 10.0034 84.9653 8.29993C84.9653 7.18614 85.6919 6.20338 86.7413 5.67924C86.6606 5.48269 86.5799 5.28614 86.5799 5.08959C86.5799 3.97579 87.6293 2.99304 89.0017 2.99304C89.5667 2.99304 90.0511 3.18959 90.4547 3.45166C91.4235 1.94476 93.1994 0.896484 95.2983 0.896484C98.2045 0.896484 100.546 2.92752 100.546 5.41717V5.67924C101.837 6.13786 102.725 7.18614 102.725 8.43097Z"
      fill="url(#paint3_linear_2242_16246)"
    />
    <path
      d="M38.3446 21.2932C38.3446 23.4484 36.1528 25.1725 33.3841 25.1725H18.0412C15.2725 25.0001 12.9653 23.3622 12.9653 21.1208C12.9653 19.6553 14.0036 18.3622 15.5033 17.6725C15.3879 17.4139 15.2725 17.1553 15.2725 16.8966C15.2725 15.4311 16.7722 14.138 18.7334 14.138C19.5409 14.138 20.233 14.3966 20.8098 14.7415C22.1942 12.7587 24.7321 11.3794 27.7315 11.3794C31.8845 11.3794 35.2299 14.0518 35.2299 17.3277V17.6725C37.0757 18.2759 38.3446 19.6553 38.3446 21.2932Z"
      fill="url(#paint4_linear_2242_16246)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.6188 23.2412C61.1129 23.2412 62.9434 26.8442 62.9434 28.9578C65.3041 29.3001 70.0692 31.7992 70.0692 36.4144C70.0692 41.0296 66.2965 43.2422 65.0548 44.2217C64.8438 44.3882 64.5824 44.5471 64.3044 44.7078L64.2056 44.7646C64.1062 44.8215 64.0053 44.8787 63.9042 44.9367L63.7527 45.0244C63.7359 45.0342 63.7191 45.044 63.7023 45.0539L63.6021 45.1135C62.4542 45.8031 61.4865 46.6483 62.9434 48.2739C64.351 49.8445 64.4454 50.6798 63.2264 50.7799H61.1129V84.0482L59.2776 85.8619H55.7688L52.4821 80.9118V78.8227L55.0629 77.2416V73.8787L53.155 71.9665V67.6584L54.6258 64.8546V59.0676L52.4821 57.1299V50.7799H50.6606C48.9977 50.7815 48.9977 49.9462 50.6606 48.2739C51.9796 46.8674 51.4895 45.5375 48.8233 44.2217C46.6229 43.2334 43.1756 40.4623 43.6266 36.4144C43.9969 32.7331 46.3415 30.2476 50.6606 28.9578C51.6367 25.1467 53.6228 23.2412 56.6188 23.2412ZM56.9657 27.1033C54.909 27.1033 53.2416 28.7706 53.2416 30.8274C53.2416 32.8842 54.909 34.5516 56.9657 34.5516C59.0225 34.5516 60.6899 32.8842 60.6899 30.8274C60.6899 28.7706 59.0225 27.1033 56.9657 27.1033Z"
      stroke="url(#paint5_linear_2242_16246)"
    />
    <path
      d="M58.8254 23.2412C63.3194 23.2412 65.1499 26.8442 65.1499 28.9578C67.5106 29.3001 72.2757 31.7992 72.2757 36.4144C72.2757 41.0296 68.503 43.2422 67.2614 44.2217C67.0876 44.3588 66.8796 44.4908 66.6564 44.6228L66.5598 44.6794C66.4786 44.7266 66.3958 44.7739 66.3123 44.8216L66.2117 44.8789C64.9178 45.6176 63.5241 46.4598 65.1499 48.2739C66.5576 49.8445 66.6519 50.6798 65.433 50.7799H63.3194V84.0482L61.4842 85.8619H57.9754L54.6887 80.9118V78.8227L57.2695 77.2416V73.8787L55.3615 71.9665V67.6584L56.8323 64.8546V59.0676L54.6887 57.1299V50.7799H52.8671C51.2042 50.7815 51.2042 49.9462 52.8671 48.2739C54.1862 46.8674 53.6961 45.5375 51.0299 44.2217C48.8295 43.2334 45.3822 40.4623 45.8332 36.4144C46.2034 32.7331 48.5481 30.2476 52.8671 28.9578C53.8432 25.1467 55.8293 23.2412 58.8254 23.2412ZM59.1723 27.1033C57.1155 27.1033 55.4481 28.7706 55.4481 30.8274C55.4481 32.8842 57.1155 34.5516 59.1723 34.5516C61.2291 34.5516 62.8964 32.8842 62.8964 30.8274C62.8964 28.7706 61.2291 27.1033 59.1723 27.1033Z"
      fill="url(#paint6_linear_2242_16246)"
    />
    <path
      d="M93.5169 26C95.3451 26 96.8272 27.4821 96.8272 29.3103C96.8272 31.1386 95.3451 32.6207 93.5169 32.6207C91.6886 32.6207 90.2065 31.1386 90.2065 29.3103C90.2065 27.4821 91.6886 26 93.5169 26ZM93.5169 27.3793C92.4504 27.3793 91.5859 28.2439 91.5859 29.3103C91.5859 30.3768 92.4504 31.2414 93.5169 31.2414C94.5834 31.2414 95.4479 30.3768 95.4479 29.3103C95.4479 28.2439 94.5834 27.3793 93.5169 27.3793Z"
      fill="url(#paint7_linear_2242_16246)"
    />
    <path
      d="M31.1723 34.2759C32.0864 34.2759 32.8274 35.0169 32.8274 35.9311C32.8274 36.8452 32.0864 37.5862 31.1723 37.5862C30.2581 37.5862 29.5171 36.8452 29.5171 35.9311C29.5171 35.0169 30.2581 34.2759 31.1723 34.2759ZM31.1723 34.9655C30.639 34.9655 30.2067 35.3978 30.2067 35.9311C30.2067 36.4643 30.639 36.8966 31.1723 36.8966C31.7055 36.8966 32.1378 36.4643 32.1378 35.9311C32.1378 35.3978 31.7055 34.9655 31.1723 34.9655Z"
      fill="url(#paint8_linear_2242_16246)"
    />
    <path
      d="M87.9999 56.0688C88.6094 56.0688 89.1034 56.5629 89.1034 57.1723C89.1034 57.7817 88.6094 58.2757 87.9999 58.2757C87.3905 58.2757 86.8965 57.7817 86.8965 57.1723C86.8965 56.5629 87.3905 56.0688 87.9999 56.0688ZM87.9999 56.5286C87.6444 56.5286 87.3563 56.8168 87.3563 57.1723C87.3563 57.5278 87.6444 57.816 87.9999 57.816C88.3554 57.816 88.6436 57.5278 88.6436 57.1723C88.6436 56.8168 88.3554 56.5286 87.9999 56.5286Z"
      fill="url(#paint9_linear_2242_16246)"
    />
    <path
      d="M53.7927 6.41357C54.2498 6.41357 54.6203 6.7841 54.6203 7.24116V9.44806H56.8272C57.2843 9.44806 57.6548 9.81858 57.6548 10.2756C57.6548 10.7327 57.2843 11.1032 56.8272 11.1032H54.6203V13.3101C54.6203 13.7672 54.2498 14.1377 53.7927 14.1377C53.3357 14.1377 52.9651 13.7672 52.9651 13.3101V11.1032H50.7583C50.3012 11.1032 49.9307 10.7327 49.9307 10.2756C49.9307 9.81858 50.3012 9.44806 50.7583 9.44806H52.9651V7.24116C52.9651 6.7841 53.3357 6.41357 53.7927 6.41357Z"
      fill="url(#paint10_linear_2242_16246)"
    />
    <path
      d="M79.9998 40.3447C80.3046 40.3447 80.5516 40.5917 80.5516 40.8965V42.2755L81.9309 42.2758C82.2356 42.2758 82.4826 42.5228 82.4826 42.8275C82.4826 43.1322 82.2356 43.3792 81.9309 43.3792H80.5516V44.7585C80.5516 45.0632 80.3046 45.3102 79.9998 45.3102C79.6951 45.3102 79.4481 45.0632 79.4481 44.7585V43.3792H78.0688C77.7641 43.3792 77.5171 43.1322 77.5171 42.8275C77.5171 42.5228 77.7641 42.2758 78.0688 42.2758H79.4481V40.8965C79.4481 40.5917 79.6951 40.3447 79.9998 40.3447Z"
      fill="url(#paint11_linear_2242_16246)"
    />
    <path
      d="M35.0345 51.9307C35.3731 51.9307 35.6475 52.2051 35.6475 52.5437L35.6475 54.076L37.1801 54.0763C37.5187 54.0763 37.7931 54.3507 37.7931 54.6893C37.7931 55.0278 37.5187 55.3023 37.1801 55.3023L35.6475 55.3023L35.6475 56.8349C35.6475 57.1734 35.3731 57.4479 35.0345 57.4479C34.6959 57.4479 34.4215 57.1734 34.4215 56.8349L34.4213 55.3023L32.8889 55.3023C32.5503 55.3023 32.2759 55.0278 32.2759 54.6893C32.2759 54.3507 32.5503 54.0763 32.8889 54.0763L34.4213 54.076L34.4215 52.5437C34.4215 52.2051 34.6959 51.9307 35.0345 51.9307Z"
      fill="url(#paint12_linear_2242_16246)"
    />
    <path
      d="M93.5169 26C95.3451 26 96.8272 27.4821 96.8272 29.3103C96.8272 31.1386 95.3451 32.6207 93.5169 32.6207C91.6886 32.6207 90.2065 31.1386 90.2065 29.3103C90.2065 27.4821 91.6886 26 93.5169 26ZM93.5169 27.3793C92.4504 27.3793 91.5859 28.2439 91.5859 29.3103C91.5859 30.3768 92.4504 31.2414 93.5169 31.2414C94.5834 31.2414 95.4479 30.3768 95.4479 29.3103C95.4479 28.2439 94.5834 27.3793 93.5169 27.3793Z"
      fill="url(#paint13_linear_2242_16246)"
    />
    <path
      d="M31.1723 34.2759C32.0864 34.2759 32.8274 35.0169 32.8274 35.9311C32.8274 36.8452 32.0864 37.5862 31.1723 37.5862C30.2581 37.5862 29.5171 36.8452 29.5171 35.9311C29.5171 35.0169 30.2581 34.2759 31.1723 34.2759ZM31.1723 34.9655C30.639 34.9655 30.2067 35.3978 30.2067 35.9311C30.2067 36.4643 30.639 36.8966 31.1723 36.8966C31.7055 36.8966 32.1378 36.4643 32.1378 35.9311C32.1378 35.3978 31.7055 34.9655 31.1723 34.9655Z"
      fill="url(#paint14_linear_2242_16246)"
    />
    <path
      d="M87.9999 56.0688C88.6094 56.0688 89.1034 56.5629 89.1034 57.1723C89.1034 57.7817 88.6094 58.2757 87.9999 58.2757C87.3905 58.2757 86.8965 57.7817 86.8965 57.1723C86.8965 56.5629 87.3905 56.0688 87.9999 56.0688ZM87.9999 56.5286C87.6444 56.5286 87.3563 56.8168 87.3563 57.1723C87.3563 57.5278 87.6444 57.816 87.9999 57.816C88.3554 57.816 88.6436 57.5278 88.6436 57.1723C88.6436 56.8168 88.3554 56.5286 87.9999 56.5286Z"
      fill="url(#paint15_linear_2242_16246)"
    />
    <path
      d="M53.7927 6.41357C54.2498 6.41357 54.6203 6.7841 54.6203 7.24116V9.44806H56.8272C57.2843 9.44806 57.6548 9.81858 57.6548 10.2756C57.6548 10.7327 57.2843 11.1032 56.8272 11.1032H54.6203V13.3101C54.6203 13.7672 54.2498 14.1377 53.7927 14.1377C53.3357 14.1377 52.9651 13.7672 52.9651 13.3101V11.1032H50.7583C50.3012 11.1032 49.9307 10.7327 49.9307 10.2756C49.9307 9.81858 50.3012 9.44806 50.7583 9.44806H52.9651V7.24116C52.9651 6.7841 53.3357 6.41357 53.7927 6.41357Z"
      fill="url(#paint16_linear_2242_16246)"
    />
    <path
      d="M79.9998 40.3447C80.3046 40.3447 80.5516 40.5917 80.5516 40.8965V42.2755L81.9309 42.2758C82.2356 42.2758 82.4826 42.5228 82.4826 42.8275C82.4826 43.1322 82.2356 43.3792 81.9309 43.3792H80.5516V44.7585C80.5516 45.0632 80.3046 45.3102 79.9998 45.3102C79.6951 45.3102 79.4481 45.0632 79.4481 44.7585V43.3792H78.0688C77.7641 43.3792 77.5171 43.1322 77.5171 42.8275C77.5171 42.5228 77.7641 42.2758 78.0688 42.2758H79.4481V40.8965C79.4481 40.5917 79.6951 40.3447 79.9998 40.3447Z"
      fill="url(#paint17_linear_2242_16246)"
    />
    <path
      d="M35.0345 51.9307C35.3731 51.9307 35.6475 52.2051 35.6475 52.5437L35.6475 54.076L37.1801 54.0763C37.5187 54.0763 37.7931 54.3507 37.7931 54.6893C37.7931 55.0278 37.5187 55.3023 37.1801 55.3023L35.6475 55.3023L35.6475 56.8349C35.6475 57.1734 35.3731 57.4479 35.0345 57.4479C34.6959 57.4479 34.4215 57.1734 34.4215 56.8349L34.4213 55.3023L32.8889 55.3023C32.5503 55.3023 32.2759 55.0278 32.2759 54.6893C32.2759 54.3507 32.5503 54.0763 32.8889 54.0763L34.4213 54.076L34.4215 52.5437C34.4215 52.2051 34.6959 51.9307 35.0345 51.9307Z"
      fill="url(#paint18_linear_2242_16246)"
    />
    <path
      d="M87.0347 86.9657H69.1037C68.1134 86.9657 67.3105 86.1669 67.3105 85.1818V72.6944C67.3105 71.7092 68.1134 70.9105 69.1037 70.9105H70.8968V67.3427C70.8968 63.4012 74.1082 60.207 78.0692 60.207C82.0302 60.207 85.2416 63.4012 85.2416 67.3427V70.9105H87.0347C88.0249 70.9105 88.8278 71.7092 88.8278 72.6944V85.1818C88.8278 86.1669 88.0249 86.9657 87.0347 86.9657ZM77.1726 79.6663V82.5059C77.1726 82.998 77.5736 83.3979 78.0691 83.3979C78.5647 83.3979 78.9657 82.998 78.9657 82.5059V79.6663C80.0076 79.297 80.7588 78.317 80.7588 77.1542C80.7588 75.676 79.5549 74.4783 78.0691 74.4783C76.5834 74.4783 75.3795 75.676 75.3795 77.1542C75.3795 78.317 76.1307 79.297 77.1726 79.6663ZM81.6554 67.3427C81.6554 65.3723 80.0496 63.7749 78.0691 63.7749C76.0887 63.7749 74.483 65.3724 74.483 67.3427V70.9105H81.6554V67.3427Z"
      fill="url(#paint19_linear_2242_16246)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2242_16246"
        x1="29.793"
        y1="69.5862"
        x2="13.5171"
        y2="69.5862"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2242_16246"
        x1="115.31"
        y1="69.5862"
        x2="99.0342"
        y2="69.5862"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2242_16246"
        x1="105.103"
        y1="72.2067"
        x2="92.4136"
        y2="72.2067"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2242_16246"
        x1="102.725"
        y1="6.13786"
        x2="84.9653"
        y2="6.13786"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2242_16246"
        x1="38.3446"
        y1="18.2759"
        x2="12.9653"
        y2="18.2759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" stop-opacity="0.2" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2242_16246"
        x1="56.8278"
        y1="23.2412"
        x2="56.8278"
        y2="88.6205"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-5)" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2242_16246"
        x1="59.0343"
        y1="23.2412"
        x2="59.0343"
        y2="88.6205"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-5)" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2242_16246"
        x1="421.241"
        y1="688.069"
        x2="421.241"
        y2="-48.3225"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={EmptyColors.gray300} />
        <stop offset="1" stop-color={EmptyColors.gray100} />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2242_16246"
        x1="195.034"
        y1="365.31"
        x2="195.034"
        y2="-2.88538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={EmptyColors.gray300} />
        <stop offset="1" stop-color={EmptyColors.gray100} />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2242_16246"
        x1="197.241"
        y1="276.759"
        x2="197.241"
        y2="31.2947"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={EmptyColors.gray300} />
        <stop offset="1" stop-color={EmptyColors.gray100} />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2242_16246"
        x1="436.138"
        y1="778.827"
        x2="436.138"
        y2="-80.296"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={EmptyColors.gray300} />
        <stop offset="1" stop-color={EmptyColors.gray100} />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2242_16246"
        x1="325.793"
        y1="536.896"
        x2="325.793"
        y2="-15.3972"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={EmptyColors.gray300} />
        <stop offset="1" stop-color={EmptyColors.gray100} />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2242_16246"
        x1="308.138"
        y1="603.655"
        x2="308.138"
        y2="-10.0048"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color={EmptyColors.gray300} />
        <stop offset="1" stop-color={EmptyColors.gray100} />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2242_16246"
        x1="93.5169"
        y1="32.3842"
        x2="96.1407"
        y2="27.0555"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2242_16246"
        x1="31.1723"
        y1="37.468"
        x2="32.4842"
        y2="34.8036"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2242_16246"
        x1="87.9999"
        y1="58.1969"
        x2="88.8745"
        y2="56.4207"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_2242_16246"
        x1="53.7927"
        y1="13.8619"
        x2="56.8538"
        y2="7.64495"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_2242_16246"
        x1="79.9998"
        y1="45.1329"
        x2="81.9677"
        y2="41.1363"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_2242_16246"
        x1="35.0345"
        y1="57.2509"
        x2="37.221"
        y2="52.8102"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-3)" />
        <stop offset="1" stop-color="var(--xzx-brand-2)" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_2242_16246"
        x1="78.0692"
        y1="60.207"
        x2="78.0692"
        y2="86.9657"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="var(--xzx-brand-2)" />
        <stop offset="1" stop-color="var(--xzx-brand-5)" />
      </linearGradient>
    </defs>
  </svg>
)
